/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./graphql";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getDataUsers = /* GraphQL */ `query GetDataUsers($type: DataUserContext!, $userId: ID, $isExclude: Boolean!) {
  getDataUsers(type: $type, userId: $userId, isExclude: $isExclude) {
    circles {
      cirlceId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      CGPcercent
      isOrganizer
      __typename
    }
    events {
      eventId
      event {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      CGPcercent
      isOrganizer
      __typename
    }
    users {
      userId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      CGPercent
      __typename
    }
    skills {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillTracks {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDataUsersQueryVariables,
  APITypes.GetDataUsersQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    cognitoID
    email
    organizationGroup
    firstName
    lastName
    username
    avatarUrl
    bannerImageUrl
    bio
    jobTitle
    type
    lookingForType
    isClosedForAcceptingMentee
    joinedAt
    lastLoginAt
    deletedAt
    deletedBy
    phone
    points
    lifetimePoints
    dateOfBirth
    isOnboarded
    disabledQuickQuestion
    finishedUserGuideContext
    focusedSkillTrack {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    minimumIntroducers
    givenRatings {
      items {
        id
        userFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        organizationGroup
        ratingValue
        comment
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    receivedRatings {
      items {
        id
        userFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        organizationGroup
        ratingValue
        comment
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    averageRating
    avgMentorRating
    avgMenteeRating
    avgAllyRating
    userHomepageConfig
    socialMedia {
      linkedIn
      __typename
    }
    targetGoals {
      circle
      event
      connection
      __typename
    }
    interest
    expertises
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    awards
    titleRank
    sensitiveQuestionConsent
    isAskedTwiceAlready
    skippedSensitiveQuestion {
      dateOfBirth
      sexuality
      religion
      class
      relationshipStatus
      category
      taxBracket
      nativeBorn
      birthCity
      moonSign
      sunSign
      generation
      favePoliticalParty
      __typename
    }
    ethnicity
    sexuality
    extrovertOrIntrovert
    sensingOrIntuition
    thinkingOrFeeling
    judgingOrPerceiving
    personalityType
    religion
    class
    relationshipStatus
    childhoodZip
    dogOwner
    catOwner
    moonSign
    sunSign
    morningVsNightPerson
    hasSiblings
    birthOrder
    heroes
    sages
    celebsLoveToMeet
    personalityTest
    eatOutVsEatIn
    almaMater
    gender
    race
    vegan
    taxBracket
    nativeBorn
    currentZip
    artist
    musicalInstrument
    generation
    companyClub
    favorites {
      faveMusicGenre
      faveSinger
      faveMuseum
      faveSportTeam
      faveSport
      faveLanguage
      faveTVShow
      faveBoardGame
      faveVideoGame
      faveBook
      faveTheatreShow
      faveVacation
      faveNewsSource
      faveCity
      faveRestaurant
      faveBar
      faveNightClub
      favePoliticalParty
      faveCharities
      faveDrink
      __typename
    }
    workBehaviours {
      collaboration
      motivation
      pressure
      workLifeBalance
      communication
      openOfficeEnvirontment
      contributorOrManager
      __typename
    }
    totalSiblings
    vegetarian
    birthCountry
    birthCity
    introVsExtro
    selectedFavorites
    zipCode
    collegeMajor
    isFirstGenerationCollege
    highSchool
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    userFocusedSkillTrackId
    userDepartmentId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const syncUsers = /* GraphQL */ `query SyncUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUsers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncUsersQueryVariables, APITypes.SyncUsersQuery>;
export const usersByCognitoID = /* GraphQL */ `query UsersByCognitoID(
  $cognitoID: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByCognitoID(
    cognitoID: $cognitoID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByCognitoIDQueryVariables,
  APITypes.UsersByCognitoIDQuery
>;
export const usersByEmail = /* GraphQL */ `query UsersByEmail(
  $email: AWSEmail!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByEmailQueryVariables,
  APITypes.UsersByEmailQuery
>;
export const usersByOrganizationGroupAndJoinedAt = /* GraphQL */ `query UsersByOrganizationGroupAndJoinedAt(
  $organizationGroup: String!
  $joinedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByOrganizationGroupAndJoinedAt(
    organizationGroup: $organizationGroup
    joinedAt: $joinedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByOrganizationGroupAndJoinedAtQueryVariables,
  APITypes.UsersByOrganizationGroupAndJoinedAtQuery
>;
export const usersByOrganizationGroupAndFirstName = /* GraphQL */ `query UsersByOrganizationGroupAndFirstName(
  $organizationGroup: String!
  $firstName: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByOrganizationGroupAndFirstName(
    organizationGroup: $organizationGroup
    firstName: $firstName
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByOrganizationGroupAndFirstNameQueryVariables,
  APITypes.UsersByOrganizationGroupAndFirstNameQuery
>;
export const usersByOrganizationGroupAndLastLoginAt = /* GraphQL */ `query UsersByOrganizationGroupAndLastLoginAt(
  $organizationGroup: String!
  $lastLoginAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByOrganizationGroupAndLastLoginAt(
    organizationGroup: $organizationGroup
    lastLoginAt: $lastLoginAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByOrganizationGroupAndLastLoginAtQueryVariables,
  APITypes.UsersByOrganizationGroupAndLastLoginAtQuery
>;
export const getUserExternalNotificationSettings = /* GraphQL */ `query GetUserExternalNotificationSettings($id: ID!) {
  getUserExternalNotificationSettings(id: $id) {
    id
    userID
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    extNotificationChannel
    extUserID
    isEnabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserExternalNotificationSettingsQueryVariables,
  APITypes.GetUserExternalNotificationSettingsQuery
>;
export const listUserExternalNotificationSettings = /* GraphQL */ `query ListUserExternalNotificationSettings(
  $filter: ModelUserExternalNotificationSettingsFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserExternalNotificationSettings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      extNotificationChannel
      extUserID
      isEnabled
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserExternalNotificationSettingsQueryVariables,
  APITypes.ListUserExternalNotificationSettingsQuery
>;
export const syncUserExternalNotificationSettings = /* GraphQL */ `query SyncUserExternalNotificationSettings(
  $filter: ModelUserExternalNotificationSettingsFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserExternalNotificationSettings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      extNotificationChannel
      extUserID
      isEnabled
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserExternalNotificationSettingsQueryVariables,
  APITypes.SyncUserExternalNotificationSettingsQuery
>;
export const userExternalNotificationSettingsByUserID = /* GraphQL */ `query UserExternalNotificationSettingsByUserID(
  $userID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserExternalNotificationSettingsFilterInput
  $limit: Int
  $nextToken: String
) {
  userExternalNotificationSettingsByUserID(
    userID: $userID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      extNotificationChannel
      extUserID
      isEnabled
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserExternalNotificationSettingsByUserIDQueryVariables,
  APITypes.UserExternalNotificationSettingsByUserIDQuery
>;
export const userExternalNotificationSettingsByExtUserID = /* GraphQL */ `query UserExternalNotificationSettingsByExtUserID(
  $extUserID: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserExternalNotificationSettingsFilterInput
  $limit: Int
  $nextToken: String
) {
  userExternalNotificationSettingsByExtUserID(
    extUserID: $extUserID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      extNotificationChannel
      extUserID
      isEnabled
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserExternalNotificationSettingsByExtUserIDQueryVariables,
  APITypes.UserExternalNotificationSettingsByExtUserIDQuery
>;
export const getUserRating = /* GraphQL */ `query GetUserRating($id: ID!) {
  getUserRating(id: $id) {
    id
    userFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToType
    organizationGroup
    ratingValue
    comment
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserRatingQueryVariables,
  APITypes.GetUserRatingQuery
>;
export const listUserRatings = /* GraphQL */ `query ListUserRatings(
  $filter: ModelUserRatingFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserRatings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      organizationGroup
      ratingValue
      comment
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserRatingsQueryVariables,
  APITypes.ListUserRatingsQuery
>;
export const syncUserRatings = /* GraphQL */ `query SyncUserRatings(
  $filter: ModelUserRatingFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserRatings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      organizationGroup
      ratingValue
      comment
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserRatingsQueryVariables,
  APITypes.SyncUserRatingsQuery
>;
export const userRatingsByUserFromIdAndCreatedAt = /* GraphQL */ `query UserRatingsByUserFromIdAndCreatedAt(
  $userFromId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserRatingFilterInput
  $limit: Int
  $nextToken: String
) {
  userRatingsByUserFromIdAndCreatedAt(
    userFromId: $userFromId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      organizationGroup
      ratingValue
      comment
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserRatingsByUserFromIdAndCreatedAtQueryVariables,
  APITypes.UserRatingsByUserFromIdAndCreatedAtQuery
>;
export const userRatingsByUserToIdAndCreatedAt = /* GraphQL */ `query UserRatingsByUserToIdAndCreatedAt(
  $userToId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserRatingFilterInput
  $limit: Int
  $nextToken: String
) {
  userRatingsByUserToIdAndCreatedAt(
    userToId: $userToId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      organizationGroup
      ratingValue
      comment
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserRatingsByUserToIdAndCreatedAtQueryVariables,
  APITypes.UserRatingsByUserToIdAndCreatedAtQuery
>;
export const userRatingsByOrganizationGroup = /* GraphQL */ `query UserRatingsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserRatingFilterInput
  $limit: Int
  $nextToken: String
) {
  userRatingsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      organizationGroup
      ratingValue
      comment
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserRatingsByOrganizationGroupQueryVariables,
  APITypes.UserRatingsByOrganizationGroupQuery
>;
export const getUserAggregateData = /* GraphQL */ `query GetUserAggregateData($id: ID!) {
  getUserAggregateData(id: $id) {
    id
    organizationGroup
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    searchableName
    searchableDepartmentName
    expertiseNames
    interestNames
    allies
    mentors
    superMentors
    mentees
    sponsorees
    skillIds
    circleIds
    eventIds
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserAggregateDataQueryVariables,
  APITypes.GetUserAggregateDataQuery
>;
export const listUserAggregateData = /* GraphQL */ `query ListUserAggregateData(
  $filter: ModelUserAggregateDataFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserAggregateData(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      searchableName
      searchableDepartmentName
      expertiseNames
      interestNames
      allies
      mentors
      superMentors
      mentees
      sponsorees
      skillIds
      circleIds
      eventIds
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserAggregateDataQueryVariables,
  APITypes.ListUserAggregateDataQuery
>;
export const syncUserAggregateData = /* GraphQL */ `query SyncUserAggregateData(
  $filter: ModelUserAggregateDataFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserAggregateData(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      searchableName
      searchableDepartmentName
      expertiseNames
      interestNames
      allies
      mentors
      superMentors
      mentees
      sponsorees
      skillIds
      circleIds
      eventIds
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserAggregateDataQueryVariables,
  APITypes.SyncUserAggregateDataQuery
>;
export const userAggregateDataByOrganizationGroup = /* GraphQL */ `query UserAggregateDataByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserAggregateDataFilterInput
  $limit: Int
  $nextToken: String
) {
  userAggregateDataByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      searchableName
      searchableDepartmentName
      expertiseNames
      interestNames
      allies
      mentors
      superMentors
      mentees
      sponsorees
      skillIds
      circleIds
      eventIds
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserAggregateDataByOrganizationGroupQueryVariables,
  APITypes.UserAggregateDataByOrganizationGroupQuery
>;
export const getUserPointsLogs = /* GraphQL */ `query GetUserPointsLogs($id: ID!) {
  getUserPointsLogs(id: $id) {
    id
    userID
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    otherUserID
    organizationGroup
    amount
    amountBefore
    amountAfter
    lifetimePoints
    title
    description
    referenceType
    eventType
    referenceID
    eventID
    dynamoEventID
    tableARN
    linkType
    linkID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserPointsLogsQueryVariables,
  APITypes.GetUserPointsLogsQuery
>;
export const listUserPointsLogs = /* GraphQL */ `query ListUserPointsLogs(
  $filter: ModelUserPointsLogsFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserPointsLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      otherUserID
      organizationGroup
      amount
      amountBefore
      amountAfter
      lifetimePoints
      title
      description
      referenceType
      eventType
      referenceID
      eventID
      dynamoEventID
      tableARN
      linkType
      linkID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserPointsLogsQueryVariables,
  APITypes.ListUserPointsLogsQuery
>;
export const syncUserPointsLogs = /* GraphQL */ `query SyncUserPointsLogs(
  $filter: ModelUserPointsLogsFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserPointsLogs(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      otherUserID
      organizationGroup
      amount
      amountBefore
      amountAfter
      lifetimePoints
      title
      description
      referenceType
      eventType
      referenceID
      eventID
      dynamoEventID
      tableARN
      linkType
      linkID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserPointsLogsQueryVariables,
  APITypes.SyncUserPointsLogsQuery
>;
export const userPointsLogsByUserID = /* GraphQL */ `query UserPointsLogsByUserID(
  $userID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserPointsLogsFilterInput
  $limit: Int
  $nextToken: String
) {
  userPointsLogsByUserID(
    userID: $userID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      otherUserID
      organizationGroup
      amount
      amountBefore
      amountAfter
      lifetimePoints
      title
      description
      referenceType
      eventType
      referenceID
      eventID
      dynamoEventID
      tableARN
      linkType
      linkID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserPointsLogsByUserIDQueryVariables,
  APITypes.UserPointsLogsByUserIDQuery
>;
export const userPointsLogsByOrganizationGroupAndCreatedAt = /* GraphQL */ `query UserPointsLogsByOrganizationGroupAndCreatedAt(
  $organizationGroup: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserPointsLogsFilterInput
  $limit: Int
  $nextToken: String
) {
  userPointsLogsByOrganizationGroupAndCreatedAt(
    organizationGroup: $organizationGroup
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      otherUserID
      organizationGroup
      amount
      amountBefore
      amountAfter
      lifetimePoints
      title
      description
      referenceType
      eventType
      referenceID
      eventID
      dynamoEventID
      tableARN
      linkType
      linkID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserPointsLogsByOrganizationGroupAndCreatedAtQueryVariables,
  APITypes.UserPointsLogsByOrganizationGroupAndCreatedAtQuery
>;
export const userPointsLogsByReferenceTypeAndCreatedAt = /* GraphQL */ `query UserPointsLogsByReferenceTypeAndCreatedAt(
  $referenceType: NotificationType!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserPointsLogsFilterInput
  $limit: Int
  $nextToken: String
) {
  userPointsLogsByReferenceTypeAndCreatedAt(
    referenceType: $referenceType
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      otherUserID
      organizationGroup
      amount
      amountBefore
      amountAfter
      lifetimePoints
      title
      description
      referenceType
      eventType
      referenceID
      eventID
      dynamoEventID
      tableARN
      linkType
      linkID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserPointsLogsByReferenceTypeAndCreatedAtQueryVariables,
  APITypes.UserPointsLogsByReferenceTypeAndCreatedAtQuery
>;
export const userPointsLogsByReferenceID = /* GraphQL */ `query UserPointsLogsByReferenceID(
  $referenceID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserPointsLogsFilterInput
  $limit: Int
  $nextToken: String
) {
  userPointsLogsByReferenceID(
    referenceID: $referenceID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      otherUserID
      organizationGroup
      amount
      amountBefore
      amountAfter
      lifetimePoints
      title
      description
      referenceType
      eventType
      referenceID
      eventID
      dynamoEventID
      tableARN
      linkType
      linkID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserPointsLogsByReferenceIDQueryVariables,
  APITypes.UserPointsLogsByReferenceIDQuery
>;
export const getOrganization = /* GraphQL */ `query GetOrganization($id: ID!) {
  getOrganization(id: $id) {
    id
    name
    domain
    isPremium
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrganizationQueryVariables,
  APITypes.GetOrganizationQuery
>;
export const listOrganizations = /* GraphQL */ `query ListOrganizations(
  $filter: ModelOrganizationFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      domain
      isPremium
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrganizationsQueryVariables,
  APITypes.ListOrganizationsQuery
>;
export const syncOrganizations = /* GraphQL */ `query SyncOrganizations(
  $filter: ModelOrganizationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncOrganizations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      domain
      isPremium
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncOrganizationsQueryVariables,
  APITypes.SyncOrganizationsQuery
>;
export const getOrganizationSetting = /* GraphQL */ `query GetOrganizationSetting($id: ID!) {
  getOrganizationSetting(id: $id) {
    id
    organizationGroup
    updatedBy
    disclaimer
    waivers
    privacyPolicy
    termsConditions
    allowAllCreateCircle
    allowAllCreateEvent
    maxNoOfMinIntroducers
    onboarding {
      key
      value
      __typename
    }
    pointTiers {
      platinum
      gold
      silver
      bronze
      __typename
    }
    slackBotToken
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrganizationSettingQueryVariables,
  APITypes.GetOrganizationSettingQuery
>;
export const listOrganizationSettings = /* GraphQL */ `query ListOrganizationSettings(
  $filter: ModelOrganizationSettingFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrganizationSettings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      updatedBy
      disclaimer
      waivers
      privacyPolicy
      termsConditions
      allowAllCreateCircle
      allowAllCreateEvent
      maxNoOfMinIntroducers
      onboarding {
        key
        value
        __typename
      }
      pointTiers {
        platinum
        gold
        silver
        bronze
        __typename
      }
      slackBotToken
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrganizationSettingsQueryVariables,
  APITypes.ListOrganizationSettingsQuery
>;
export const syncOrganizationSettings = /* GraphQL */ `query SyncOrganizationSettings(
  $filter: ModelOrganizationSettingFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncOrganizationSettings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      updatedBy
      disclaimer
      waivers
      privacyPolicy
      termsConditions
      allowAllCreateCircle
      allowAllCreateEvent
      maxNoOfMinIntroducers
      onboarding {
        key
        value
        __typename
      }
      pointTiers {
        platinum
        gold
        silver
        bronze
        __typename
      }
      slackBotToken
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncOrganizationSettingsQueryVariables,
  APITypes.SyncOrganizationSettingsQuery
>;
export const organizationSettingsByOrganizationGroup = /* GraphQL */ `query OrganizationSettingsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelOrganizationSettingFilterInput
  $limit: Int
  $nextToken: String
) {
  organizationSettingsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      updatedBy
      disclaimer
      waivers
      privacyPolicy
      termsConditions
      allowAllCreateCircle
      allowAllCreateEvent
      maxNoOfMinIntroducers
      onboarding {
        key
        value
        __typename
      }
      pointTiers {
        platinum
        gold
        silver
        bronze
        __typename
      }
      slackBotToken
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrganizationSettingsByOrganizationGroupQueryVariables,
  APITypes.OrganizationSettingsByOrganizationGroupQuery
>;
export const getDepartment = /* GraphQL */ `query GetDepartment($id: ID!) {
  getDepartment(id: $id) {
    id
    name
    description
    organizationGroup
    skillTracks {
      items {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    levels {
      items {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDepartmentQueryVariables,
  APITypes.GetDepartmentQuery
>;
export const listDepartments = /* GraphQL */ `query ListDepartments(
  $filter: ModelDepartmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listDepartments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDepartmentsQueryVariables,
  APITypes.ListDepartmentsQuery
>;
export const syncDepartments = /* GraphQL */ `query SyncDepartments(
  $filter: ModelDepartmentFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncDepartments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncDepartmentsQueryVariables,
  APITypes.SyncDepartmentsQuery
>;
export const departmentsByOrganizationGroup = /* GraphQL */ `query DepartmentsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelDepartmentFilterInput
  $limit: Int
  $nextToken: String
) {
  departmentsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DepartmentsByOrganizationGroupQueryVariables,
  APITypes.DepartmentsByOrganizationGroupQuery
>;
export const getChampion = /* GraphQL */ `query GetChampion($id: ID!) {
  getChampion(id: $id) {
    id
    organizationGroup
    userFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    status
    requestMessage
    approvedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChampionQueryVariables,
  APITypes.GetChampionQuery
>;
export const listChampions = /* GraphQL */ `query ListChampions(
  $filter: ModelChampionFilterInput
  $limit: Int
  $nextToken: String
) {
  listChampions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      status
      requestMessage
      approvedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChampionsQueryVariables,
  APITypes.ListChampionsQuery
>;
export const syncChampions = /* GraphQL */ `query SyncChampions(
  $filter: ModelChampionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncChampions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      status
      requestMessage
      approvedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncChampionsQueryVariables,
  APITypes.SyncChampionsQuery
>;
export const championsByOrganizationGroup = /* GraphQL */ `query ChampionsByOrganizationGroup(
  $organizationGroup: String!
  $approvedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelChampionFilterInput
  $limit: Int
  $nextToken: String
) {
  championsByOrganizationGroup(
    organizationGroup: $organizationGroup
    approvedAt: $approvedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      status
      requestMessage
      approvedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ChampionsByOrganizationGroupQueryVariables,
  APITypes.ChampionsByOrganizationGroupQuery
>;
export const championsByUserFromId = /* GraphQL */ `query ChampionsByUserFromId(
  $userFromId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelChampionFilterInput
  $limit: Int
  $nextToken: String
) {
  championsByUserFromId(
    userFromId: $userFromId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      status
      requestMessage
      approvedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ChampionsByUserFromIdQueryVariables,
  APITypes.ChampionsByUserFromIdQuery
>;
export const championsByUserToId = /* GraphQL */ `query ChampionsByUserToId(
  $userToId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelChampionFilterInput
  $limit: Int
  $nextToken: String
) {
  championsByUserToId(
    userToId: $userToId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      status
      requestMessage
      approvedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ChampionsByUserToIdQueryVariables,
  APITypes.ChampionsByUserToIdQuery
>;
export const getDepartmentLevel = /* GraphQL */ `query GetDepartmentLevel($id: ID!) {
  getDepartmentLevel(id: $id) {
    id
    organizationGroup
    departmentId
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    name
    rank
    skills {
      items {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDepartmentLevelQueryVariables,
  APITypes.GetDepartmentLevelQuery
>;
export const listDepartmentLevels = /* GraphQL */ `query ListDepartmentLevels(
  $filter: ModelDepartmentLevelFilterInput
  $limit: Int
  $nextToken: String
) {
  listDepartmentLevels(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      name
      rank
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDepartmentLevelsQueryVariables,
  APITypes.ListDepartmentLevelsQuery
>;
export const syncDepartmentLevels = /* GraphQL */ `query SyncDepartmentLevels(
  $filter: ModelDepartmentLevelFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncDepartmentLevels(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      name
      rank
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncDepartmentLevelsQueryVariables,
  APITypes.SyncDepartmentLevelsQuery
>;
export const departmentLevelsByOrganizationGroup = /* GraphQL */ `query DepartmentLevelsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelDepartmentLevelFilterInput
  $limit: Int
  $nextToken: String
) {
  departmentLevelsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      name
      rank
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DepartmentLevelsByOrganizationGroupQueryVariables,
  APITypes.DepartmentLevelsByOrganizationGroupQuery
>;
export const departmentLevelsByDepartmentIdAndRank = /* GraphQL */ `query DepartmentLevelsByDepartmentIdAndRank(
  $departmentId: ID!
  $rank: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDepartmentLevelFilterInput
  $limit: Int
  $nextToken: String
) {
  departmentLevelsByDepartmentIdAndRank(
    departmentId: $departmentId
    rank: $rank
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      name
      rank
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DepartmentLevelsByDepartmentIdAndRankQueryVariables,
  APITypes.DepartmentLevelsByDepartmentIdAndRankQuery
>;
export const getCircle = /* GraphQL */ `query GetCircle($id: ID!) {
  getCircle(id: $id) {
    id
    name
    description
    imageUrl
    privacy
    event {
      items {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interest
    organizationGroup
    admins
    members {
      items {
        id
        organizationGroup
        role
        status
        requestStatus
        circleUserCircleId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        circleUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        circleUserInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    isManagedByHR
    creator
    bannerImageUrl
    CGPercent
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetCircleQueryVariables, APITypes.GetCircleQuery>;
export const listCircles = /* GraphQL */ `query ListCircles(
  $filter: ModelCircleFilterInput
  $limit: Int
  $nextToken: String
) {
  listCircles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCirclesQueryVariables,
  APITypes.ListCirclesQuery
>;
export const syncCircles = /* GraphQL */ `query SyncCircles(
  $filter: ModelCircleFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCircles(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCirclesQueryVariables,
  APITypes.SyncCirclesQuery
>;
export const circlesByOrganizationGroupAndCreatedAt = /* GraphQL */ `query CirclesByOrganizationGroupAndCreatedAt(
  $organizationGroup: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCircleFilterInput
  $limit: Int
  $nextToken: String
) {
  circlesByOrganizationGroupAndCreatedAt(
    organizationGroup: $organizationGroup
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CirclesByOrganizationGroupAndCreatedAtQueryVariables,
  APITypes.CirclesByOrganizationGroupAndCreatedAtQuery
>;
export const getCircleUser = /* GraphQL */ `query GetCircleUser($id: ID!) {
  getCircleUser(id: $id) {
    id
    organizationGroup
    role
    status
    requestStatus
    circleUserCircleId
    circle {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    circleUserUserId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviterNotes
    isInviterHR
    requestNotes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    circleUserInviterId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCircleUserQueryVariables,
  APITypes.GetCircleUserQuery
>;
export const listCircleUsers = /* GraphQL */ `query ListCircleUsers(
  $filter: ModelCircleUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listCircleUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      role
      status
      requestStatus
      circleUserCircleId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      circleUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      circleUserInviterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCircleUsersQueryVariables,
  APITypes.ListCircleUsersQuery
>;
export const syncCircleUsers = /* GraphQL */ `query SyncCircleUsers(
  $filter: ModelCircleUserFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCircleUsers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      role
      status
      requestStatus
      circleUserCircleId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      circleUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      circleUserInviterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCircleUsersQueryVariables,
  APITypes.SyncCircleUsersQuery
>;
export const createdAtByOrganizationGroup = /* GraphQL */ `query CreatedAtByOrganizationGroup(
  $organizationGroup: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCircleUserFilterInput
  $limit: Int
  $nextToken: String
) {
  createdAtByOrganizationGroup(
    organizationGroup: $organizationGroup
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      role
      status
      requestStatus
      circleUserCircleId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      circleUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      circleUserInviterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CreatedAtByOrganizationGroupQueryVariables,
  APITypes.CreatedAtByOrganizationGroupQuery
>;
export const circleUsersByCircleUserCircleId = /* GraphQL */ `query CircleUsersByCircleUserCircleId(
  $circleUserCircleId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCircleUserFilterInput
  $limit: Int
  $nextToken: String
) {
  circleUsersByCircleUserCircleId(
    circleUserCircleId: $circleUserCircleId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      role
      status
      requestStatus
      circleUserCircleId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      circleUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      circleUserInviterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CircleUsersByCircleUserCircleIdQueryVariables,
  APITypes.CircleUsersByCircleUserCircleIdQuery
>;
export const circleUsersByCircleUserUserId = /* GraphQL */ `query CircleUsersByCircleUserUserId(
  $circleUserUserId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCircleUserFilterInput
  $limit: Int
  $nextToken: String
) {
  circleUsersByCircleUserUserId(
    circleUserUserId: $circleUserUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      role
      status
      requestStatus
      circleUserCircleId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      circleUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      circleUserInviterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CircleUsersByCircleUserUserIdQueryVariables,
  APITypes.CircleUsersByCircleUserUserIdQuery
>;
export const getVisit = /* GraphQL */ `query GetVisit($id: ID!) {
  getVisit(id: $id) {
    id
    contextId
    contextType
    visitorId
    organizationGroup
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetVisitQueryVariables, APITypes.GetVisitQuery>;
export const listVisits = /* GraphQL */ `query ListVisits(
  $filter: ModelVisitFilterInput
  $limit: Int
  $nextToken: String
) {
  listVisits(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      contextId
      contextType
      visitorId
      organizationGroup
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVisitsQueryVariables,
  APITypes.ListVisitsQuery
>;
export const syncVisits = /* GraphQL */ `query SyncVisits(
  $filter: ModelVisitFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncVisits(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      contextId
      contextType
      visitorId
      organizationGroup
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncVisitsQueryVariables,
  APITypes.SyncVisitsQuery
>;
export const visitsByContextId = /* GraphQL */ `query VisitsByContextId(
  $contextId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelVisitFilterInput
  $limit: Int
  $nextToken: String
) {
  visitsByContextId(
    contextId: $contextId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      contextId
      contextType
      visitorId
      organizationGroup
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VisitsByContextIdQueryVariables,
  APITypes.VisitsByContextIdQuery
>;
export const visitsByVisitorId = /* GraphQL */ `query VisitsByVisitorId(
  $visitorId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelVisitFilterInput
  $limit: Int
  $nextToken: String
) {
  visitsByVisitorId(
    visitorId: $visitorId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      contextId
      contextType
      visitorId
      organizationGroup
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VisitsByVisitorIdQueryVariables,
  APITypes.VisitsByVisitorIdQuery
>;
export const getTag = /* GraphQL */ `query GetTag($id: ID!) {
  getTag(id: $id) {
    id
    organizationGroup
    name
    description
    type
    category
    tagCategoryId
    tagCategory {
      id
      organizationGroup
      name
      tags {
        items {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTagQueryVariables, APITypes.GetTagQuery>;
export const listTags = /* GraphQL */ `query ListTags($filter: ModelTagFilterInput, $limit: Int, $nextToken: String) {
  listTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTagsQueryVariables, APITypes.ListTagsQuery>;
export const syncTags = /* GraphQL */ `query SyncTags(
  $filter: ModelTagFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTags(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncTagsQueryVariables, APITypes.SyncTagsQuery>;
export const tagsByOrganizationGroup = /* GraphQL */ `query TagsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelTagFilterInput
  $limit: Int
  $nextToken: String
) {
  tagsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TagsByOrganizationGroupQueryVariables,
  APITypes.TagsByOrganizationGroupQuery
>;
export const tagsByTagCategoryId = /* GraphQL */ `query TagsByTagCategoryId(
  $tagCategoryId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTagFilterInput
  $limit: Int
  $nextToken: String
) {
  tagsByTagCategoryId(
    tagCategoryId: $tagCategoryId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TagsByTagCategoryIdQueryVariables,
  APITypes.TagsByTagCategoryIdQuery
>;
export const getTagCategory = /* GraphQL */ `query GetTagCategory($id: ID!) {
  getTagCategory(id: $id) {
    id
    organizationGroup
    name
    tags {
      items {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTagCategoryQueryVariables,
  APITypes.GetTagCategoryQuery
>;
export const listTagCategories = /* GraphQL */ `query ListTagCategories(
  $filter: ModelTagCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listTagCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      name
      tags {
        items {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTagCategoriesQueryVariables,
  APITypes.ListTagCategoriesQuery
>;
export const syncTagCategories = /* GraphQL */ `query SyncTagCategories(
  $filter: ModelTagCategoryFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTagCategories(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      name
      tags {
        items {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTagCategoriesQueryVariables,
  APITypes.SyncTagCategoriesQuery
>;
export const tagCategoriesByOrganizationGroup = /* GraphQL */ `query TagCategoriesByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelTagCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  tagCategoriesByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      name
      tags {
        items {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TagCategoriesByOrganizationGroupQueryVariables,
  APITypes.TagCategoriesByOrganizationGroupQuery
>;
export const getSkillTrack = /* GraphQL */ `query GetSkillTrack($id: ID!) {
  getSkillTrack(id: $id) {
    id
    organizationGroup
    departmentId
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tag {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillTrackTagId
    name
    color
    skills {
      items {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillTrackQueryVariables,
  APITypes.GetSkillTrackQuery
>;
export const listSkillTracks = /* GraphQL */ `query ListSkillTracks(
  $filter: ModelSkillTrackFilterInput
  $limit: Int
  $nextToken: String
) {
  listSkillTracks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSkillTracksQueryVariables,
  APITypes.ListSkillTracksQuery
>;
export const syncSkillTracks = /* GraphQL */ `query SyncSkillTracks(
  $filter: ModelSkillTrackFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSkillTracks(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSkillTracksQueryVariables,
  APITypes.SyncSkillTracksQuery
>;
export const skillTracksByOrganizationGroup = /* GraphQL */ `query SkillTracksByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelSkillTrackFilterInput
  $limit: Int
  $nextToken: String
) {
  skillTracksByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillTracksByOrganizationGroupQueryVariables,
  APITypes.SkillTracksByOrganizationGroupQuery
>;
export const skillTracksByDepartmentId = /* GraphQL */ `query SkillTracksByDepartmentId(
  $departmentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSkillTrackFilterInput
  $limit: Int
  $nextToken: String
) {
  skillTracksByDepartmentId(
    departmentId: $departmentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillTracksByDepartmentIdQueryVariables,
  APITypes.SkillTracksByDepartmentIdQuery
>;
export const getSkill = /* GraphQL */ `query GetSkill($id: ID!) {
  getSkill(id: $id) {
    id
    organizationGroup
    name
    description
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillDepartmentId
    trackOrder
    points
    assignees {
      items {
        id
        organizationGroup
        skillId
        skill {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        completedAt
        verifiers {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    skillTrackId
    skillTrack {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    departmentlevelId
    departmentlevel {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      name
      rank
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    level
    levelRank
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetSkillQueryVariables, APITypes.GetSkillQuery>;
export const listSkills = /* GraphQL */ `query ListSkills(
  $filter: ModelSkillFilterInput
  $limit: Int
  $nextToken: String
) {
  listSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSkillsQueryVariables,
  APITypes.ListSkillsQuery
>;
export const syncSkills = /* GraphQL */ `query SyncSkills(
  $filter: ModelSkillFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSkills(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSkillsQueryVariables,
  APITypes.SyncSkillsQuery
>;
export const skillsByOrganizationGroup = /* GraphQL */ `query SkillsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelSkillFilterInput
  $limit: Int
  $nextToken: String
) {
  skillsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillsByOrganizationGroupQueryVariables,
  APITypes.SkillsByOrganizationGroupQuery
>;
export const skillsBySkillDepartmentId = /* GraphQL */ `query SkillsBySkillDepartmentId(
  $skillDepartmentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSkillFilterInput
  $limit: Int
  $nextToken: String
) {
  skillsBySkillDepartmentId(
    skillDepartmentId: $skillDepartmentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillsBySkillDepartmentIdQueryVariables,
  APITypes.SkillsBySkillDepartmentIdQuery
>;
export const skillsBySkillTrackIdAndTrackOrder = /* GraphQL */ `query SkillsBySkillTrackIdAndTrackOrder(
  $skillTrackId: ID!
  $trackOrder: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSkillFilterInput
  $limit: Int
  $nextToken: String
) {
  skillsBySkillTrackIdAndTrackOrder(
    skillTrackId: $skillTrackId
    trackOrder: $trackOrder
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillsBySkillTrackIdAndTrackOrderQueryVariables,
  APITypes.SkillsBySkillTrackIdAndTrackOrderQuery
>;
export const skillsByDepartmentlevelIdAndTrackOrder = /* GraphQL */ `query SkillsByDepartmentlevelIdAndTrackOrder(
  $departmentlevelId: ID!
  $trackOrder: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSkillFilterInput
  $limit: Int
  $nextToken: String
) {
  skillsByDepartmentlevelIdAndTrackOrder(
    departmentlevelId: $departmentlevelId
    trackOrder: $trackOrder
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillsByDepartmentlevelIdAndTrackOrderQueryVariables,
  APITypes.SkillsByDepartmentlevelIdAndTrackOrderQuery
>;
export const getSkillUser = /* GraphQL */ `query GetSkillUser($id: ID!) {
  getSkillUser(id: $id) {
    id
    organizationGroup
    skillId
    skill {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillUserUserId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    completedAt
    verifiers {
      items {
        id
        skillUserId
        skillUser {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillId
        organizationGroup
        verifierId
        verifier {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        rating
        message
        isHR
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillUserQueryVariables,
  APITypes.GetSkillUserQuery
>;
export const listSkillUsers = /* GraphQL */ `query ListSkillUsers(
  $filter: ModelSkillUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listSkillUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      skillId
      skill {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      completedAt
      verifiers {
        items {
          id
          skillUserId
          skillId
          organizationGroup
          verifierId
          rating
          message
          isHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSkillUsersQueryVariables,
  APITypes.ListSkillUsersQuery
>;
export const syncSkillUsers = /* GraphQL */ `query SyncSkillUsers(
  $filter: ModelSkillUserFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSkillUsers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      skillId
      skill {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      completedAt
      verifiers {
        items {
          id
          skillUserId
          skillId
          organizationGroup
          verifierId
          rating
          message
          isHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSkillUsersQueryVariables,
  APITypes.SyncSkillUsersQuery
>;
export const skillUsersByOrganizationGroup = /* GraphQL */ `query SkillUsersByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelSkillUserFilterInput
  $limit: Int
  $nextToken: String
) {
  skillUsersByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      skillId
      skill {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      completedAt
      verifiers {
        items {
          id
          skillUserId
          skillId
          organizationGroup
          verifierId
          rating
          message
          isHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillUsersByOrganizationGroupQueryVariables,
  APITypes.SkillUsersByOrganizationGroupQuery
>;
export const skillUsersBySkillId = /* GraphQL */ `query SkillUsersBySkillId(
  $skillId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSkillUserFilterInput
  $limit: Int
  $nextToken: String
) {
  skillUsersBySkillId(
    skillId: $skillId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      skillId
      skill {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      completedAt
      verifiers {
        items {
          id
          skillUserId
          skillId
          organizationGroup
          verifierId
          rating
          message
          isHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillUsersBySkillIdQueryVariables,
  APITypes.SkillUsersBySkillIdQuery
>;
export const skillUsersBySkillUserUserId = /* GraphQL */ `query SkillUsersBySkillUserUserId(
  $skillUserUserId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSkillUserFilterInput
  $limit: Int
  $nextToken: String
) {
  skillUsersBySkillUserUserId(
    skillUserUserId: $skillUserUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      skillId
      skill {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      completedAt
      verifiers {
        items {
          id
          skillUserId
          skillId
          organizationGroup
          verifierId
          rating
          message
          isHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillUsersBySkillUserUserIdQueryVariables,
  APITypes.SkillUsersBySkillUserUserIdQuery
>;
export const getSkillUserVerifier = /* GraphQL */ `query GetSkillUserVerifier($id: ID!) {
  getSkillUserVerifier(id: $id) {
    id
    skillUserId
    skillUser {
      id
      organizationGroup
      skillId
      skill {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      completedAt
      verifiers {
        items {
          id
          skillUserId
          skillId
          organizationGroup
          verifierId
          rating
          message
          isHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillId
    organizationGroup
    verifierId
    verifier {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    rating
    message
    isHR
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillUserVerifierQueryVariables,
  APITypes.GetSkillUserVerifierQuery
>;
export const listSkillUserVerifiers = /* GraphQL */ `query ListSkillUserVerifiers(
  $filter: ModelSkillUserVerifierFilterInput
  $limit: Int
  $nextToken: String
) {
  listSkillUserVerifiers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      skillUserId
      skillUser {
        id
        organizationGroup
        skillId
        skill {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        completedAt
        verifiers {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillId
      organizationGroup
      verifierId
      verifier {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      rating
      message
      isHR
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSkillUserVerifiersQueryVariables,
  APITypes.ListSkillUserVerifiersQuery
>;
export const syncSkillUserVerifiers = /* GraphQL */ `query SyncSkillUserVerifiers(
  $filter: ModelSkillUserVerifierFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSkillUserVerifiers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      skillUserId
      skillUser {
        id
        organizationGroup
        skillId
        skill {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        completedAt
        verifiers {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillId
      organizationGroup
      verifierId
      verifier {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      rating
      message
      isHR
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSkillUserVerifiersQueryVariables,
  APITypes.SyncSkillUserVerifiersQuery
>;
export const skillUserVerifiersBySkillUserId = /* GraphQL */ `query SkillUserVerifiersBySkillUserId(
  $skillUserId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSkillUserVerifierFilterInput
  $limit: Int
  $nextToken: String
) {
  skillUserVerifiersBySkillUserId(
    skillUserId: $skillUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      skillUserId
      skillUser {
        id
        organizationGroup
        skillId
        skill {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        completedAt
        verifiers {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillId
      organizationGroup
      verifierId
      verifier {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      rating
      message
      isHR
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillUserVerifiersBySkillUserIdQueryVariables,
  APITypes.SkillUserVerifiersBySkillUserIdQuery
>;
export const skillUserVerifiersBySkillId = /* GraphQL */ `query SkillUserVerifiersBySkillId(
  $skillId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSkillUserVerifierFilterInput
  $limit: Int
  $nextToken: String
) {
  skillUserVerifiersBySkillId(
    skillId: $skillId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      skillUserId
      skillUser {
        id
        organizationGroup
        skillId
        skill {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        completedAt
        verifiers {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillId
      organizationGroup
      verifierId
      verifier {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      rating
      message
      isHR
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillUserVerifiersBySkillIdQueryVariables,
  APITypes.SkillUserVerifiersBySkillIdQuery
>;
export const skillUserVerifiersByOrganizationGroup = /* GraphQL */ `query SkillUserVerifiersByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelSkillUserVerifierFilterInput
  $limit: Int
  $nextToken: String
) {
  skillUserVerifiersByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      skillUserId
      skillUser {
        id
        organizationGroup
        skillId
        skill {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        completedAt
        verifiers {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillId
      organizationGroup
      verifierId
      verifier {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      rating
      message
      isHR
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillUserVerifiersByOrganizationGroupQueryVariables,
  APITypes.SkillUserVerifiersByOrganizationGroupQuery
>;
export const getConnection = /* GraphQL */ `query GetConnection($id: ID!) {
  getConnection(id: $id) {
    id
    description
    status
    approvedAt
    organizationGroup
    connectionUserFromId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userFromRequestType
    userFromRequestStatus
    connectionUserToId
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userToType
    userToRequestType
    userToRequestStatus
    introductionRequests {
      items {
        id
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToType
        introducer {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        introductionRequestUserFromId
        introductionRequestUserToId
        introducerId
        reason
        status
        message
        connectionId
        connection {
          id
          description
          status
          approvedAt
          organizationGroup
          connectionUserFromId
          userFromType
          userFromRequestType
          userFromRequestStatus
          connectionUserToId
          userToType
          userToRequestType
          userToRequestStatus
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        introductionRequestIntroducerId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConnectionQueryVariables,
  APITypes.GetConnectionQuery
>;
export const listConnections = /* GraphQL */ `query ListConnections(
  $filter: ModelConnectionFilterInput
  $limit: Int
  $nextToken: String
) {
  listConnections(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListConnectionsQueryVariables,
  APITypes.ListConnectionsQuery
>;
export const syncConnections = /* GraphQL */ `query SyncConnections(
  $filter: ModelConnectionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncConnections(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncConnectionsQueryVariables,
  APITypes.SyncConnectionsQuery
>;
export const connectionsByOrganizationGroup = /* GraphQL */ `query ConnectionsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelConnectionFilterInput
  $limit: Int
  $nextToken: String
) {
  connectionsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConnectionsByOrganizationGroupQueryVariables,
  APITypes.ConnectionsByOrganizationGroupQuery
>;
export const connectionsByConnectionUserFromId = /* GraphQL */ `query ConnectionsByConnectionUserFromId(
  $connectionUserFromId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelConnectionFilterInput
  $limit: Int
  $nextToken: String
) {
  connectionsByConnectionUserFromId(
    connectionUserFromId: $connectionUserFromId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConnectionsByConnectionUserFromIdQueryVariables,
  APITypes.ConnectionsByConnectionUserFromIdQuery
>;
export const connectionsByConnectionUserToId = /* GraphQL */ `query ConnectionsByConnectionUserToId(
  $connectionUserToId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelConnectionFilterInput
  $limit: Int
  $nextToken: String
) {
  connectionsByConnectionUserToId(
    connectionUserToId: $connectionUserToId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConnectionsByConnectionUserToIdQueryVariables,
  APITypes.ConnectionsByConnectionUserToIdQuery
>;
export const getNotification = /* GraphQL */ `query GetNotification($id: ID!) {
  getNotification(id: $id) {
    id
    description
    message
    status
    userFrom
    userTo
    referenceType
    isFromHR
    createdAt
    referenceID
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNotificationQueryVariables,
  APITypes.GetNotificationQuery
>;
export const listNotifications = /* GraphQL */ `query ListNotifications(
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      description
      message
      status
      userFrom
      userTo
      referenceType
      isFromHR
      createdAt
      referenceID
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationsQueryVariables,
  APITypes.ListNotificationsQuery
>;
export const syncNotifications = /* GraphQL */ `query SyncNotifications(
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncNotifications(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      description
      message
      status
      userFrom
      userTo
      referenceType
      isFromHR
      createdAt
      referenceID
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncNotificationsQueryVariables,
  APITypes.SyncNotificationsQuery
>;
export const notificationsByUserFrom = /* GraphQL */ `query NotificationsByUserFrom(
  $userFrom: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notificationsByUserFrom(
    userFrom: $userFrom
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      description
      message
      status
      userFrom
      userTo
      referenceType
      isFromHR
      createdAt
      referenceID
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByUserFromQueryVariables,
  APITypes.NotificationsByUserFromQuery
>;
export const notificationsByUserTo = /* GraphQL */ `query NotificationsByUserTo(
  $userTo: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notificationsByUserTo(
    userTo: $userTo
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      description
      message
      status
      userFrom
      userTo
      referenceType
      isFromHR
      createdAt
      referenceID
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByUserToQueryVariables,
  APITypes.NotificationsByUserToQuery
>;
export const notificationbyReferenceAndUser = /* GraphQL */ `query NotificationbyReferenceAndUser(
  $referenceID: String!
  $userTo: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notificationbyReferenceAndUser(
    referenceID: $referenceID
    userTo: $userTo
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      description
      message
      status
      userFrom
      userTo
      referenceType
      isFromHR
      createdAt
      referenceID
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationbyReferenceAndUserQueryVariables,
  APITypes.NotificationbyReferenceAndUserQuery
>;
export const notificationbyReferenceAndUserFrom = /* GraphQL */ `query NotificationbyReferenceAndUserFrom(
  $referenceID: String!
  $userFrom: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notificationbyReferenceAndUserFrom(
    referenceID: $referenceID
    userFrom: $userFrom
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      description
      message
      status
      userFrom
      userTo
      referenceType
      isFromHR
      createdAt
      referenceID
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationbyReferenceAndUserFromQueryVariables,
  APITypes.NotificationbyReferenceAndUserFromQuery
>;
export const getContextFileResources = /* GraphQL */ `query GetContextFileResources($id: ID!) {
  getContextFileResources(id: $id) {
    id
    uploader
    fileUrl
    fileName
    fileType
    contextType
    contextID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetContextFileResourcesQueryVariables,
  APITypes.GetContextFileResourcesQuery
>;
export const listContextFileResources = /* GraphQL */ `query ListContextFileResources(
  $filter: ModelContextFileResourcesFilterInput
  $limit: Int
  $nextToken: String
) {
  listContextFileResources(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploader
      fileUrl
      fileName
      fileType
      contextType
      contextID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListContextFileResourcesQueryVariables,
  APITypes.ListContextFileResourcesQuery
>;
export const syncContextFileResources = /* GraphQL */ `query SyncContextFileResources(
  $filter: ModelContextFileResourcesFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncContextFileResources(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      uploader
      fileUrl
      fileName
      fileType
      contextType
      contextID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncContextFileResourcesQueryVariables,
  APITypes.SyncContextFileResourcesQuery
>;
export const contextFileResourcesByContextID = /* GraphQL */ `query ContextFileResourcesByContextID(
  $contextID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelContextFileResourcesFilterInput
  $limit: Int
  $nextToken: String
) {
  contextFileResourcesByContextID(
    contextID: $contextID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploader
      fileUrl
      fileName
      fileType
      contextType
      contextID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ContextFileResourcesByContextIDQueryVariables,
  APITypes.ContextFileResourcesByContextIDQuery
>;
export const getEndorsement = /* GraphQL */ `query GetEndorsement($id: ID!) {
  getEndorsement(id: $id) {
    id
    description
    status
    endorsementAssignedToId
    endorsementCreatedById
    previousEndorsementId
    previousEndorsement {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    assignedTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    createdBy {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEndorsementQueryVariables,
  APITypes.GetEndorsementQuery
>;
export const listEndorsements = /* GraphQL */ `query ListEndorsements(
  $filter: ModelEndorsementFilterInput
  $limit: Int
  $nextToken: String
) {
  listEndorsements(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEndorsementsQueryVariables,
  APITypes.ListEndorsementsQuery
>;
export const syncEndorsements = /* GraphQL */ `query SyncEndorsements(
  $filter: ModelEndorsementFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncEndorsements(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncEndorsementsQueryVariables,
  APITypes.SyncEndorsementsQuery
>;
export const endorsementsByEndorsementAssignedToId = /* GraphQL */ `query EndorsementsByEndorsementAssignedToId(
  $endorsementAssignedToId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEndorsementFilterInput
  $limit: Int
  $nextToken: String
) {
  endorsementsByEndorsementAssignedToId(
    endorsementAssignedToId: $endorsementAssignedToId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EndorsementsByEndorsementAssignedToIdQueryVariables,
  APITypes.EndorsementsByEndorsementAssignedToIdQuery
>;
export const endorsementsByEndorsementCreatedById = /* GraphQL */ `query EndorsementsByEndorsementCreatedById(
  $endorsementCreatedById: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEndorsementFilterInput
  $limit: Int
  $nextToken: String
) {
  endorsementsByEndorsementCreatedById(
    endorsementCreatedById: $endorsementCreatedById
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EndorsementsByEndorsementCreatedByIdQueryVariables,
  APITypes.EndorsementsByEndorsementCreatedByIdQuery
>;
export const endorsementsByPreviousEndorsementId = /* GraphQL */ `query EndorsementsByPreviousEndorsementId(
  $previousEndorsementId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEndorsementFilterInput
  $limit: Int
  $nextToken: String
) {
  endorsementsByPreviousEndorsementId(
    previousEndorsementId: $previousEndorsementId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EndorsementsByPreviousEndorsementIdQueryVariables,
  APITypes.EndorsementsByPreviousEndorsementIdQuery
>;
export const getEvent = /* GraphQL */ `query GetEvent($id: ID!) {
  getEvent(id: $id) {
    id
    organizationGroup
    name
    description
    imageUrl
    startTime
    endTime
    circleEventId
    circle {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    attendee {
      items {
        id
        organizationGroup
        eventAttendeeId
        event {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        eventAttendeeUserId
        status
        requestStatus
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        eventAttendeeInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interests
    privacy
    admins
    timezone
    location
    createdAt
    isManagedByHR
    owner
    isHidden
    bannerImageUrl
    CGPercent
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetEventQueryVariables, APITypes.GetEventQuery>;
export const listEvents = /* GraphQL */ `query ListEvents(
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEventsQueryVariables,
  APITypes.ListEventsQuery
>;
export const syncEvents = /* GraphQL */ `query SyncEvents(
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncEvents(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncEventsQueryVariables,
  APITypes.SyncEventsQuery
>;
export const eventsByOrganizationGroupAndStartTime = /* GraphQL */ `query EventsByOrganizationGroupAndStartTime(
  $organizationGroup: String!
  $startTime: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
) {
  eventsByOrganizationGroupAndStartTime(
    organizationGroup: $organizationGroup
    startTime: $startTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EventsByOrganizationGroupAndStartTimeQueryVariables,
  APITypes.EventsByOrganizationGroupAndStartTimeQuery
>;
export const eventsByOrganizationGroupAndCreatedAt = /* GraphQL */ `query EventsByOrganizationGroupAndCreatedAt(
  $organizationGroup: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
) {
  eventsByOrganizationGroupAndCreatedAt(
    organizationGroup: $organizationGroup
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EventsByOrganizationGroupAndCreatedAtQueryVariables,
  APITypes.EventsByOrganizationGroupAndCreatedAtQuery
>;
export const eventsByCircleEventId = /* GraphQL */ `query EventsByCircleEventId(
  $circleEventId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
) {
  eventsByCircleEventId(
    circleEventId: $circleEventId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EventsByCircleEventIdQueryVariables,
  APITypes.EventsByCircleEventIdQuery
>;
export const eventsByPrivacy = /* GraphQL */ `query EventsByPrivacy(
  $privacy: EnumPrivacy!
  $sortDirection: ModelSortDirection
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
) {
  eventsByPrivacy(
    privacy: $privacy
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EventsByPrivacyQueryVariables,
  APITypes.EventsByPrivacyQuery
>;
export const getEventAttendee = /* GraphQL */ `query GetEventAttendee($id: ID!) {
  getEventAttendee(id: $id) {
    id
    organizationGroup
    eventAttendeeId
    event {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    eventAttendeeUserId
    status
    requestStatus
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    inviterNotes
    isInviterHR
    requestNotes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    eventAttendeeInviterId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEventAttendeeQueryVariables,
  APITypes.GetEventAttendeeQuery
>;
export const listEventAttendees = /* GraphQL */ `query ListEventAttendees(
  $filter: ModelEventAttendeeFilterInput
  $limit: Int
  $nextToken: String
) {
  listEventAttendees(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      eventAttendeeId
      event {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      eventAttendeeUserId
      status
      requestStatus
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      eventAttendeeInviterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEventAttendeesQueryVariables,
  APITypes.ListEventAttendeesQuery
>;
export const syncEventAttendees = /* GraphQL */ `query SyncEventAttendees(
  $filter: ModelEventAttendeeFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncEventAttendees(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      eventAttendeeId
      event {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      eventAttendeeUserId
      status
      requestStatus
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      eventAttendeeInviterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncEventAttendeesQueryVariables,
  APITypes.SyncEventAttendeesQuery
>;
export const eventAttendeesByOrganizationGroup = /* GraphQL */ `query EventAttendeesByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelEventAttendeeFilterInput
  $limit: Int
  $nextToken: String
) {
  eventAttendeesByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      eventAttendeeId
      event {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      eventAttendeeUserId
      status
      requestStatus
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      eventAttendeeInviterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EventAttendeesByOrganizationGroupQueryVariables,
  APITypes.EventAttendeesByOrganizationGroupQuery
>;
export const eventAttendeesByEventAttendeeId = /* GraphQL */ `query EventAttendeesByEventAttendeeId(
  $eventAttendeeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEventAttendeeFilterInput
  $limit: Int
  $nextToken: String
) {
  eventAttendeesByEventAttendeeId(
    eventAttendeeId: $eventAttendeeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      eventAttendeeId
      event {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      eventAttendeeUserId
      status
      requestStatus
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      eventAttendeeInviterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EventAttendeesByEventAttendeeIdQueryVariables,
  APITypes.EventAttendeesByEventAttendeeIdQuery
>;
export const eventAttendeesByEventAttendeeUserId = /* GraphQL */ `query EventAttendeesByEventAttendeeUserId(
  $eventAttendeeUserId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelEventAttendeeFilterInput
  $limit: Int
  $nextToken: String
) {
  eventAttendeesByEventAttendeeUserId(
    eventAttendeeUserId: $eventAttendeeUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      eventAttendeeId
      event {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      eventAttendeeUserId
      status
      requestStatus
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      eventAttendeeInviterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EventAttendeesByEventAttendeeUserIdQueryVariables,
  APITypes.EventAttendeesByEventAttendeeUserIdQuery
>;
export const getRedFlag = /* GraphQL */ `query GetRedFlag($id: ID!) {
  getRedFlag(id: $id) {
    id
    organizationGroup
    description
    attachmentUrl
    referenceType
    referenceId
    referenceName
    reporter {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    issue
    status
    isCompleted
    completedAt
    isAnonymous
    comment
    comments {
      name
      message
      createdAt
      review
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    redFlagReporterId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRedFlagQueryVariables,
  APITypes.GetRedFlagQuery
>;
export const listRedFlags = /* GraphQL */ `query ListRedFlags(
  $filter: ModelRedFlagFilterInput
  $limit: Int
  $nextToken: String
) {
  listRedFlags(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      description
      attachmentUrl
      referenceType
      referenceId
      referenceName
      reporter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      issue
      status
      isCompleted
      completedAt
      isAnonymous
      comment
      comments {
        name
        message
        createdAt
        review
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      redFlagReporterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRedFlagsQueryVariables,
  APITypes.ListRedFlagsQuery
>;
export const syncRedFlags = /* GraphQL */ `query SyncRedFlags(
  $filter: ModelRedFlagFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncRedFlags(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      description
      attachmentUrl
      referenceType
      referenceId
      referenceName
      reporter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      issue
      status
      isCompleted
      completedAt
      isAnonymous
      comment
      comments {
        name
        message
        createdAt
        review
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      redFlagReporterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncRedFlagsQueryVariables,
  APITypes.SyncRedFlagsQuery
>;
export const redFlagsByOrganizationGroup = /* GraphQL */ `query RedFlagsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelRedFlagFilterInput
  $limit: Int
  $nextToken: String
) {
  redFlagsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      description
      attachmentUrl
      referenceType
      referenceId
      referenceName
      reporter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      issue
      status
      isCompleted
      completedAt
      isAnonymous
      comment
      comments {
        name
        message
        createdAt
        review
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      redFlagReporterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RedFlagsByOrganizationGroupQueryVariables,
  APITypes.RedFlagsByOrganizationGroupQuery
>;
export const redFlagsByReferenceType = /* GraphQL */ `query RedFlagsByReferenceType(
  $referenceType: RedFlagReferenceType!
  $sortDirection: ModelSortDirection
  $filter: ModelRedFlagFilterInput
  $limit: Int
  $nextToken: String
) {
  redFlagsByReferenceType(
    referenceType: $referenceType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      description
      attachmentUrl
      referenceType
      referenceId
      referenceName
      reporter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      issue
      status
      isCompleted
      completedAt
      isAnonymous
      comment
      comments {
        name
        message
        createdAt
        review
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      redFlagReporterId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RedFlagsByReferenceTypeQueryVariables,
  APITypes.RedFlagsByReferenceTypeQuery
>;
export const getReward = /* GraphQL */ `query GetReward($id: ID!) {
  getReward(id: $id) {
    id
    organizationGroup
    title
    description
    isActive
    points
    pointsDiscount
    imageUrl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetRewardQueryVariables, APITypes.GetRewardQuery>;
export const listRewards = /* GraphQL */ `query ListRewards(
  $filter: ModelRewardFilterInput
  $limit: Int
  $nextToken: String
) {
  listRewards(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      title
      description
      isActive
      points
      pointsDiscount
      imageUrl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRewardsQueryVariables,
  APITypes.ListRewardsQuery
>;
export const syncRewards = /* GraphQL */ `query SyncRewards(
  $filter: ModelRewardFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncRewards(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      title
      description
      isActive
      points
      pointsDiscount
      imageUrl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncRewardsQueryVariables,
  APITypes.SyncRewardsQuery
>;
export const rewardsByOrganizationGroup = /* GraphQL */ `query RewardsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelRewardFilterInput
  $limit: Int
  $nextToken: String
) {
  rewardsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      title
      description
      isActive
      points
      pointsDiscount
      imageUrl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RewardsByOrganizationGroupQueryVariables,
  APITypes.RewardsByOrganizationGroupQuery
>;
export const getRewardUser = /* GraphQL */ `query GetRewardUser($id: ID!) {
  getRewardUser(id: $id) {
    id
    reward {
      id
      organizationGroup
      title
      description
      isActive
      points
      pointsDiscount
      imageUrl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    rewardID
    userID
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    isUsed
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRewardUserQueryVariables,
  APITypes.GetRewardUserQuery
>;
export const listRewardUsers = /* GraphQL */ `query ListRewardUsers(
  $filter: ModelRewardUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listRewardUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      reward {
        id
        organizationGroup
        title
        description
        isActive
        points
        pointsDiscount
        imageUrl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      rewardID
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      isUsed
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRewardUsersQueryVariables,
  APITypes.ListRewardUsersQuery
>;
export const syncRewardUsers = /* GraphQL */ `query SyncRewardUsers(
  $filter: ModelRewardUserFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncRewardUsers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      reward {
        id
        organizationGroup
        title
        description
        isActive
        points
        pointsDiscount
        imageUrl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      rewardID
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      isUsed
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncRewardUsersQueryVariables,
  APITypes.SyncRewardUsersQuery
>;
export const rewardUsersByRewardID = /* GraphQL */ `query RewardUsersByRewardID(
  $rewardID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRewardUserFilterInput
  $limit: Int
  $nextToken: String
) {
  rewardUsersByRewardID(
    rewardID: $rewardID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      reward {
        id
        organizationGroup
        title
        description
        isActive
        points
        pointsDiscount
        imageUrl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      rewardID
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      isUsed
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RewardUsersByRewardIDQueryVariables,
  APITypes.RewardUsersByRewardIDQuery
>;
export const rewardUsersByUserID = /* GraphQL */ `query RewardUsersByUserID(
  $userID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRewardUserFilterInput
  $limit: Int
  $nextToken: String
) {
  rewardUsersByUserID(
    userID: $userID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      reward {
        id
        organizationGroup
        title
        description
        isActive
        points
        pointsDiscount
        imageUrl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      rewardID
      userID
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      isUsed
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RewardUsersByUserIDQueryVariables,
  APITypes.RewardUsersByUserIDQuery
>;
export const getPointRewardConfiguration = /* GraphQL */ `query GetPointRewardConfiguration($id: ID!) {
  getPointRewardConfiguration(id: $id) {
    id
    organizationGroup
    amount
    EventType
    createdAt
    category
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPointRewardConfigurationQueryVariables,
  APITypes.GetPointRewardConfigurationQuery
>;
export const listPointRewardConfigurations = /* GraphQL */ `query ListPointRewardConfigurations(
  $filter: ModelPointRewardConfigurationFilterInput
  $limit: Int
  $nextToken: String
) {
  listPointRewardConfigurations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      amount
      EventType
      createdAt
      category
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPointRewardConfigurationsQueryVariables,
  APITypes.ListPointRewardConfigurationsQuery
>;
export const syncPointRewardConfigurations = /* GraphQL */ `query SyncPointRewardConfigurations(
  $filter: ModelPointRewardConfigurationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPointRewardConfigurations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      amount
      EventType
      createdAt
      category
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPointRewardConfigurationsQueryVariables,
  APITypes.SyncPointRewardConfigurationsQuery
>;
export const sortByCreatedAt = /* GraphQL */ `query SortByCreatedAt(
  $organizationGroup: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPointRewardConfigurationFilterInput
  $limit: Int
  $nextToken: String
) {
  sortByCreatedAt(
    organizationGroup: $organizationGroup
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      amount
      EventType
      createdAt
      category
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SortByCreatedAtQueryVariables,
  APITypes.SortByCreatedAtQuery
>;
export const getCommonGround = /* GraphQL */ `query GetCommonGround($id: ID!) {
  getCommonGround(id: $id) {
    id
    userFrom
    userTo
    userToFirstName
    userToLastName
    userToEmail
    organizationGroup
    connectionId
    CGPercent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCommonGroundQueryVariables,
  APITypes.GetCommonGroundQuery
>;
export const listCommonGrounds = /* GraphQL */ `query ListCommonGrounds(
  $filter: ModelCommonGroundFilterInput
  $limit: Int
  $nextToken: String
) {
  listCommonGrounds(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userFrom
      userTo
      userToFirstName
      userToLastName
      userToEmail
      organizationGroup
      connectionId
      CGPercent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCommonGroundsQueryVariables,
  APITypes.ListCommonGroundsQuery
>;
export const syncCommonGrounds = /* GraphQL */ `query SyncCommonGrounds(
  $filter: ModelCommonGroundFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCommonGrounds(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userFrom
      userTo
      userToFirstName
      userToLastName
      userToEmail
      organizationGroup
      connectionId
      CGPercent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCommonGroundsQueryVariables,
  APITypes.SyncCommonGroundsQuery
>;
export const commonGroundByUserFrom = /* GraphQL */ `query CommonGroundByUserFrom(
  $userFrom: ID!
  $CGPercent: ModelFloatKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCommonGroundFilterInput
  $limit: Int
  $nextToken: String
) {
  commonGroundByUserFrom(
    userFrom: $userFrom
    CGPercent: $CGPercent
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom
      userTo
      userToFirstName
      userToLastName
      userToEmail
      organizationGroup
      connectionId
      CGPercent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CommonGroundByUserFromQueryVariables,
  APITypes.CommonGroundByUserFromQuery
>;
export const commonGroundByUserTo = /* GraphQL */ `query CommonGroundByUserTo(
  $userTo: ID!
  $CGPercent: ModelFloatKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCommonGroundFilterInput
  $limit: Int
  $nextToken: String
) {
  commonGroundByUserTo(
    userTo: $userTo
    CGPercent: $CGPercent
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom
      userTo
      userToFirstName
      userToLastName
      userToEmail
      organizationGroup
      connectionId
      CGPercent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CommonGroundByUserToQueryVariables,
  APITypes.CommonGroundByUserToQuery
>;
export const commonGroundsByOrganizationGroup = /* GraphQL */ `query CommonGroundsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelCommonGroundFilterInput
  $limit: Int
  $nextToken: String
) {
  commonGroundsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom
      userTo
      userToFirstName
      userToLastName
      userToEmail
      organizationGroup
      connectionId
      CGPercent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CommonGroundsByOrganizationGroupQueryVariables,
  APITypes.CommonGroundsByOrganizationGroupQuery
>;
export const getCommonGroundContext = /* GraphQL */ `query GetCommonGroundContext($id: ID!) {
  getCommonGroundContext(id: $id) {
    id
    userFrom
    organizationGroup
    referenceId
    referenceType
    CGPercent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCommonGroundContextQueryVariables,
  APITypes.GetCommonGroundContextQuery
>;
export const listCommonGroundContexts = /* GraphQL */ `query ListCommonGroundContexts(
  $filter: ModelCommonGroundContextFilterInput
  $limit: Int
  $nextToken: String
) {
  listCommonGroundContexts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom
      organizationGroup
      referenceId
      referenceType
      CGPercent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCommonGroundContextsQueryVariables,
  APITypes.ListCommonGroundContextsQuery
>;
export const syncCommonGroundContexts = /* GraphQL */ `query SyncCommonGroundContexts(
  $filter: ModelCommonGroundContextFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCommonGroundContexts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userFrom
      organizationGroup
      referenceId
      referenceType
      CGPercent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCommonGroundContextsQueryVariables,
  APITypes.SyncCommonGroundContextsQuery
>;
export const commonGroundontextByUserFrom = /* GraphQL */ `query CommonGroundontextByUserFrom(
  $userFrom: ID!
  $CGPercent: ModelFloatKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCommonGroundContextFilterInput
  $limit: Int
  $nextToken: String
) {
  commonGroundontextByUserFrom(
    userFrom: $userFrom
    CGPercent: $CGPercent
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom
      organizationGroup
      referenceId
      referenceType
      CGPercent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CommonGroundontextByUserFromQueryVariables,
  APITypes.CommonGroundontextByUserFromQuery
>;
export const commonGroundContextsByOrganizationGroup = /* GraphQL */ `query CommonGroundContextsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelCommonGroundContextFilterInput
  $limit: Int
  $nextToken: String
) {
  commonGroundContextsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom
      organizationGroup
      referenceId
      referenceType
      CGPercent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CommonGroundContextsByOrganizationGroupQueryVariables,
  APITypes.CommonGroundContextsByOrganizationGroupQuery
>;
export const commonGroundContextsByReferenceId = /* GraphQL */ `query CommonGroundContextsByReferenceId(
  $referenceId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCommonGroundContextFilterInput
  $limit: Int
  $nextToken: String
) {
  commonGroundContextsByReferenceId(
    referenceId: $referenceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom
      organizationGroup
      referenceId
      referenceType
      CGPercent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CommonGroundContextsByReferenceIdQueryVariables,
  APITypes.CommonGroundContextsByReferenceIdQuery
>;
export const commonGroundContextsByReferenceType = /* GraphQL */ `query CommonGroundContextsByReferenceType(
  $referenceType: CommonGroundReferenceType!
  $sortDirection: ModelSortDirection
  $filter: ModelCommonGroundContextFilterInput
  $limit: Int
  $nextToken: String
) {
  commonGroundContextsByReferenceType(
    referenceType: $referenceType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom
      organizationGroup
      referenceId
      referenceType
      CGPercent
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CommonGroundContextsByReferenceTypeQueryVariables,
  APITypes.CommonGroundContextsByReferenceTypeQuery
>;
export const getPrivacySettings = /* GraphQL */ `query GetPrivacySettings($id: ID!) {
  getPrivacySettings(id: $id) {
    id
    user
    organization {
      type
      isActivelyLooking
      __typename
    }
    industry {
      type
      isActivelyLooking
      __typename
    }
    interests {
      type
      isActivelyLooking
      __typename
    }
    birthLocation {
      type
      isActivelyLooking
      __typename
    }
    zodiacSign {
      type
      isActivelyLooking
      __typename
    }
    personalityType {
      type
      isActivelyLooking
      __typename
    }
    gender {
      type
      isActivelyLooking
      __typename
    }
    sexuality {
      type
      isActivelyLooking
      __typename
    }
    ethnicity {
      type
      isActivelyLooking
      __typename
    }
    endorsement {
      type
      isActivelyLooking
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrivacySettingsQueryVariables,
  APITypes.GetPrivacySettingsQuery
>;
export const listPrivacySettings = /* GraphQL */ `query ListPrivacySettings(
  $filter: ModelPrivacySettingsFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrivacySettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      user
      organization {
        type
        isActivelyLooking
        __typename
      }
      industry {
        type
        isActivelyLooking
        __typename
      }
      interests {
        type
        isActivelyLooking
        __typename
      }
      birthLocation {
        type
        isActivelyLooking
        __typename
      }
      zodiacSign {
        type
        isActivelyLooking
        __typename
      }
      personalityType {
        type
        isActivelyLooking
        __typename
      }
      gender {
        type
        isActivelyLooking
        __typename
      }
      sexuality {
        type
        isActivelyLooking
        __typename
      }
      ethnicity {
        type
        isActivelyLooking
        __typename
      }
      endorsement {
        type
        isActivelyLooking
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrivacySettingsQueryVariables,
  APITypes.ListPrivacySettingsQuery
>;
export const syncPrivacySettings = /* GraphQL */ `query SyncPrivacySettings(
  $filter: ModelPrivacySettingsFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPrivacySettings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      user
      organization {
        type
        isActivelyLooking
        __typename
      }
      industry {
        type
        isActivelyLooking
        __typename
      }
      interests {
        type
        isActivelyLooking
        __typename
      }
      birthLocation {
        type
        isActivelyLooking
        __typename
      }
      zodiacSign {
        type
        isActivelyLooking
        __typename
      }
      personalityType {
        type
        isActivelyLooking
        __typename
      }
      gender {
        type
        isActivelyLooking
        __typename
      }
      sexuality {
        type
        isActivelyLooking
        __typename
      }
      ethnicity {
        type
        isActivelyLooking
        __typename
      }
      endorsement {
        type
        isActivelyLooking
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPrivacySettingsQueryVariables,
  APITypes.SyncPrivacySettingsQuery
>;
export const getIntroductionRequest = /* GraphQL */ `query GetIntroductionRequest($id: ID!) {
  getIntroductionRequest(id: $id) {
    id
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userTo {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userFromType
    userToType
    introducer {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    introductionRequestUserFromId
    introductionRequestUserToId
    introducerId
    reason
    status
    message
    connectionId
    connection {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    introductionRequestIntroducerId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetIntroductionRequestQueryVariables,
  APITypes.GetIntroductionRequestQuery
>;
export const listIntroductionRequests = /* GraphQL */ `query ListIntroductionRequests(
  $filter: ModelIntroductionRequestFilterInput
  $limit: Int
  $nextToken: String
) {
  listIntroductionRequests(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userToType
      introducer {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      introductionRequestUserFromId
      introductionRequestUserToId
      introducerId
      reason
      status
      message
      connectionId
      connection {
        id
        description
        status
        approvedAt
        organizationGroup
        connectionUserFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userFromRequestType
        userFromRequestStatus
        connectionUserToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        userToRequestType
        userToRequestStatus
        introductionRequests {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      introductionRequestIntroducerId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListIntroductionRequestsQueryVariables,
  APITypes.ListIntroductionRequestsQuery
>;
export const syncIntroductionRequests = /* GraphQL */ `query SyncIntroductionRequests(
  $filter: ModelIntroductionRequestFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncIntroductionRequests(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userToType
      introducer {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      introductionRequestUserFromId
      introductionRequestUserToId
      introducerId
      reason
      status
      message
      connectionId
      connection {
        id
        description
        status
        approvedAt
        organizationGroup
        connectionUserFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userFromRequestType
        userFromRequestStatus
        connectionUserToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        userToRequestType
        userToRequestStatus
        introductionRequests {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      introductionRequestIntroducerId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncIntroductionRequestsQueryVariables,
  APITypes.SyncIntroductionRequestsQuery
>;
export const introductionRequestsByIntroductionRequestUserFromId = /* GraphQL */ `query IntroductionRequestsByIntroductionRequestUserFromId(
  $introductionRequestUserFromId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelIntroductionRequestFilterInput
  $limit: Int
  $nextToken: String
) {
  introductionRequestsByIntroductionRequestUserFromId(
    introductionRequestUserFromId: $introductionRequestUserFromId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userToType
      introducer {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      introductionRequestUserFromId
      introductionRequestUserToId
      introducerId
      reason
      status
      message
      connectionId
      connection {
        id
        description
        status
        approvedAt
        organizationGroup
        connectionUserFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userFromRequestType
        userFromRequestStatus
        connectionUserToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        userToRequestType
        userToRequestStatus
        introductionRequests {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      introductionRequestIntroducerId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IntroductionRequestsByIntroductionRequestUserFromIdQueryVariables,
  APITypes.IntroductionRequestsByIntroductionRequestUserFromIdQuery
>;
export const introductionRequestsByIntroductionRequestUserToId = /* GraphQL */ `query IntroductionRequestsByIntroductionRequestUserToId(
  $introductionRequestUserToId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelIntroductionRequestFilterInput
  $limit: Int
  $nextToken: String
) {
  introductionRequestsByIntroductionRequestUserToId(
    introductionRequestUserToId: $introductionRequestUserToId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userToType
      introducer {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      introductionRequestUserFromId
      introductionRequestUserToId
      introducerId
      reason
      status
      message
      connectionId
      connection {
        id
        description
        status
        approvedAt
        organizationGroup
        connectionUserFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userFromRequestType
        userFromRequestStatus
        connectionUserToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        userToRequestType
        userToRequestStatus
        introductionRequests {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      introductionRequestIntroducerId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IntroductionRequestsByIntroductionRequestUserToIdQueryVariables,
  APITypes.IntroductionRequestsByIntroductionRequestUserToIdQuery
>;
export const introductionRequestsByIntroducerId = /* GraphQL */ `query IntroductionRequestsByIntroducerId(
  $introducerId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelIntroductionRequestFilterInput
  $limit: Int
  $nextToken: String
) {
  introductionRequestsByIntroducerId(
    introducerId: $introducerId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userToType
      introducer {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      introductionRequestUserFromId
      introductionRequestUserToId
      introducerId
      reason
      status
      message
      connectionId
      connection {
        id
        description
        status
        approvedAt
        organizationGroup
        connectionUserFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userFromRequestType
        userFromRequestStatus
        connectionUserToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        userToRequestType
        userToRequestStatus
        introductionRequests {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      introductionRequestIntroducerId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IntroductionRequestsByIntroducerIdQueryVariables,
  APITypes.IntroductionRequestsByIntroducerIdQuery
>;
export const introductionRequestsByConnectionId = /* GraphQL */ `query IntroductionRequestsByConnectionId(
  $connectionId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelIntroductionRequestFilterInput
  $limit: Int
  $nextToken: String
) {
  introductionRequestsByConnectionId(
    connectionId: $connectionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userToType
      introducer {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      introductionRequestUserFromId
      introductionRequestUserToId
      introducerId
      reason
      status
      message
      connectionId
      connection {
        id
        description
        status
        approvedAt
        organizationGroup
        connectionUserFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userFromRequestType
        userFromRequestStatus
        connectionUserToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        userToRequestType
        userToRequestStatus
        introductionRequests {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      introductionRequestIntroducerId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IntroductionRequestsByConnectionIdQueryVariables,
  APITypes.IntroductionRequestsByConnectionIdQuery
>;
export const getPost = /* GraphQL */ `query GetPost($id: ID!) {
  getPost(id: $id) {
    id
    organizationGroup
    author {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    postAuthorId
    contextType
    contextName
    contextPrivacy
    contextImage
    isContextHidden
    category
    contextId
    content
    likeUsers
    attachments
    createdAt
    isAuthorHR
    isContextDeleted
    isHighlight
    audienceType
    audienceID
    comments {
      items {
        id
        post {
          id
          organizationGroup
          postAuthorId
          contextType
          contextName
          contextPrivacy
          contextImage
          isContextHidden
          category
          contextId
          content
          likeUsers
          attachments
          createdAt
          isAuthorHR
          isContextDeleted
          isHighlight
          audienceType
          audienceID
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        commentPostId
        organizationGroup
        author {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        commentAuthorId
        likeUsers
        message
        isAuthorHR
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetPostQueryVariables, APITypes.GetPostQuery>;
export const listPosts = /* GraphQL */ `query ListPosts(
  $filter: ModelPostFilterInput
  $limit: Int
  $nextToken: String
) {
  listPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListPostsQueryVariables, APITypes.ListPostsQuery>;
export const syncPosts = /* GraphQL */ `query SyncPosts(
  $filter: ModelPostFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPosts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncPostsQueryVariables, APITypes.SyncPostsQuery>;
export const postsByOrganizationGroup = /* GraphQL */ `query PostsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelPostFilterInput
  $limit: Int
  $nextToken: String
) {
  postsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PostsByOrganizationGroupQueryVariables,
  APITypes.PostsByOrganizationGroupQuery
>;
export const postsByPostAuthorIdAndCreatedAt = /* GraphQL */ `query PostsByPostAuthorIdAndCreatedAt(
  $postAuthorId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPostFilterInput
  $limit: Int
  $nextToken: String
) {
  postsByPostAuthorIdAndCreatedAt(
    postAuthorId: $postAuthorId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PostsByPostAuthorIdAndCreatedAtQueryVariables,
  APITypes.PostsByPostAuthorIdAndCreatedAtQuery
>;
export const postsByCategoryAndCreatedAt = /* GraphQL */ `query PostsByCategoryAndCreatedAt(
  $category: PostCategory!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPostFilterInput
  $limit: Int
  $nextToken: String
) {
  postsByCategoryAndCreatedAt(
    category: $category
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PostsByCategoryAndCreatedAtQueryVariables,
  APITypes.PostsByCategoryAndCreatedAtQuery
>;
export const postsByContextIdAndCreatedAt = /* GraphQL */ `query PostsByContextIdAndCreatedAt(
  $contextId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPostFilterInput
  $limit: Int
  $nextToken: String
) {
  postsByContextIdAndCreatedAt(
    contextId: $contextId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PostsByContextIdAndCreatedAtQueryVariables,
  APITypes.PostsByContextIdAndCreatedAtQuery
>;
export const postsByAudienceIDAndCreatedAt = /* GraphQL */ `query PostsByAudienceIDAndCreatedAt(
  $audienceID: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPostFilterInput
  $limit: Int
  $nextToken: String
) {
  postsByAudienceIDAndCreatedAt(
    audienceID: $audienceID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PostsByAudienceIDAndCreatedAtQueryVariables,
  APITypes.PostsByAudienceIDAndCreatedAtQuery
>;
export const getComment = /* GraphQL */ `query GetComment($id: ID!) {
  getComment(id: $id) {
    id
    post {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    commentPostId
    organizationGroup
    author {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    commentAuthorId
    likeUsers
    message
    isAuthorHR
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCommentQueryVariables,
  APITypes.GetCommentQuery
>;
export const listComments = /* GraphQL */ `query ListComments(
  $filter: ModelCommentFilterInput
  $limit: Int
  $nextToken: String
) {
  listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      post {
        id
        organizationGroup
        author {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        postAuthorId
        contextType
        contextName
        contextPrivacy
        contextImage
        isContextHidden
        category
        contextId
        content
        likeUsers
        attachments
        createdAt
        isAuthorHR
        isContextDeleted
        isHighlight
        audienceType
        audienceID
        comments {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      commentPostId
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      commentAuthorId
      likeUsers
      message
      isAuthorHR
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCommentsQueryVariables,
  APITypes.ListCommentsQuery
>;
export const syncComments = /* GraphQL */ `query SyncComments(
  $filter: ModelCommentFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncComments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      post {
        id
        organizationGroup
        author {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        postAuthorId
        contextType
        contextName
        contextPrivacy
        contextImage
        isContextHidden
        category
        contextId
        content
        likeUsers
        attachments
        createdAt
        isAuthorHR
        isContextDeleted
        isHighlight
        audienceType
        audienceID
        comments {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      commentPostId
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      commentAuthorId
      likeUsers
      message
      isAuthorHR
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCommentsQueryVariables,
  APITypes.SyncCommentsQuery
>;
export const commentsByCommentPostId = /* GraphQL */ `query CommentsByCommentPostId(
  $commentPostId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCommentFilterInput
  $limit: Int
  $nextToken: String
) {
  commentsByCommentPostId(
    commentPostId: $commentPostId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      post {
        id
        organizationGroup
        author {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        postAuthorId
        contextType
        contextName
        contextPrivacy
        contextImage
        isContextHidden
        category
        contextId
        content
        likeUsers
        attachments
        createdAt
        isAuthorHR
        isContextDeleted
        isHighlight
        audienceType
        audienceID
        comments {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      commentPostId
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      commentAuthorId
      likeUsers
      message
      isAuthorHR
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CommentsByCommentPostIdQueryVariables,
  APITypes.CommentsByCommentPostIdQuery
>;
export const getAnnouncement = /* GraphQL */ `query GetAnnouncement($id: ID!) {
  getAnnouncement(id: $id) {
    id
    organizationGroup
    title
    message
    messageSource
    createdBy
    isActive
    isGlobal
    departmentIds
    createdAt
    deletedAt
    deletedBy
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAnnouncementQueryVariables,
  APITypes.GetAnnouncementQuery
>;
export const listAnnouncements = /* GraphQL */ `query ListAnnouncements(
  $filter: ModelAnnouncementFilterInput
  $limit: Int
  $nextToken: String
) {
  listAnnouncements(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      title
      message
      messageSource
      createdBy
      isActive
      isGlobal
      departmentIds
      createdAt
      deletedAt
      deletedBy
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAnnouncementsQueryVariables,
  APITypes.ListAnnouncementsQuery
>;
export const syncAnnouncements = /* GraphQL */ `query SyncAnnouncements(
  $filter: ModelAnnouncementFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAnnouncements(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      title
      message
      messageSource
      createdBy
      isActive
      isGlobal
      departmentIds
      createdAt
      deletedAt
      deletedBy
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAnnouncementsQueryVariables,
  APITypes.SyncAnnouncementsQuery
>;
export const announcementsByOrganizationGroup = /* GraphQL */ `query AnnouncementsByOrganizationGroup(
  $organizationGroup: String!
  $sortDirection: ModelSortDirection
  $filter: ModelAnnouncementFilterInput
  $limit: Int
  $nextToken: String
) {
  announcementsByOrganizationGroup(
    organizationGroup: $organizationGroup
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      title
      message
      messageSource
      createdBy
      isActive
      isGlobal
      departmentIds
      createdAt
      deletedAt
      deletedBy
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AnnouncementsByOrganizationGroupQueryVariables,
  APITypes.AnnouncementsByOrganizationGroupQuery
>;
export const announcementsByCreatedBy = /* GraphQL */ `query AnnouncementsByCreatedBy(
  $createdBy: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAnnouncementFilterInput
  $limit: Int
  $nextToken: String
) {
  announcementsByCreatedBy(
    createdBy: $createdBy
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      title
      message
      messageSource
      createdBy
      isActive
      isGlobal
      departmentIds
      createdAt
      deletedAt
      deletedBy
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AnnouncementsByCreatedByQueryVariables,
  APITypes.AnnouncementsByCreatedByQuery
>;
export const announcementsByDeletedBy = /* GraphQL */ `query AnnouncementsByDeletedBy(
  $deletedBy: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAnnouncementFilterInput
  $limit: Int
  $nextToken: String
) {
  announcementsByDeletedBy(
    deletedBy: $deletedBy
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      title
      message
      messageSource
      createdBy
      isActive
      isGlobal
      departmentIds
      createdAt
      deletedAt
      deletedBy
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AnnouncementsByDeletedByQueryVariables,
  APITypes.AnnouncementsByDeletedByQuery
>;
export const getNote = /* GraphQL */ `query GetNote($id: ID!) {
  getNote(id: $id) {
    id
    organizationGroup
    author {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    noteAuthorId
    userToId
    message
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetNoteQueryVariables, APITypes.GetNoteQuery>;
export const listNotes = /* GraphQL */ `query ListNotes(
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      noteAuthorId
      userToId
      message
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListNotesQueryVariables, APITypes.ListNotesQuery>;
export const syncNotes = /* GraphQL */ `query SyncNotes(
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncNotes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      noteAuthorId
      userToId
      message
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncNotesQueryVariables, APITypes.SyncNotesQuery>;
export const notesByNoteAuthorIdAndCreatedAt = /* GraphQL */ `query NotesByNoteAuthorIdAndCreatedAt(
  $noteAuthorId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  notesByNoteAuthorIdAndCreatedAt(
    noteAuthorId: $noteAuthorId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      noteAuthorId
      userToId
      message
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotesByNoteAuthorIdAndCreatedAtQueryVariables,
  APITypes.NotesByNoteAuthorIdAndCreatedAtQuery
>;
export const notesByUserToIdAndUpdatedAt = /* GraphQL */ `query NotesByUserToIdAndUpdatedAt(
  $userToId: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  notesByUserToIdAndUpdatedAt(
    userToId: $userToId
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      noteAuthorId
      userToId
      message
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotesByUserToIdAndUpdatedAtQueryVariables,
  APITypes.NotesByUserToIdAndUpdatedAtQuery
>;
export const getUserView = /* GraphQL */ `query GetUserView($userId: String, $flag: UserViewFlagging) {
  getUserView(userId: $userId, flag: $flag) {
    userId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userConnectionType
    currentUserConnectionType
    interests {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    expertises {
      id
      organizationGroup
      name
      description
      type
      category
      tagCategoryId
      tagCategory {
        id
        organizationGroup
        name
        tags {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    fanCount
    endorsements {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    focusedSkill {
      skillId
      skillTrackId
      skillTrackName
      color
      name
      description
      points
      __typename
    }
    champions {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    isFan
    isConnected
    mutualConnection {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    CGPercent
    currentChampion {
      id
      organizationGroup
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      status
      requestMessage
      approvedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    currentConnection {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    connectionUsers {
      id
      firstName
      lastName
      avatarUrl
      type
      lookingForType
      points
      connectionType
      __typename
    }
    currentUserRating {
      id
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      organizationGroup
      ratingValue
      comment
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pendingConnection {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    isCompletedFocusedSkill
    userHomepageConfig
    userHomepageConfigMobile
    disabledQuickQuestion
    announcements {
      id
      organizationGroup
      title
      message
      messageSource
      createdBy
      isActive
      isGlobal
      departmentIds
      createdAt
      deletedAt
      deletedBy
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserViewQueryVariables,
  APITypes.GetUserViewQuery
>;
export const searchUser = /* GraphQL */ `query SearchUser($input: SearchUserParam) {
  searchUser(input: $input) {
    data {
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      CGPercent
      connectionId
      connectionType
      currentConnectionType
      isChampion
      mutualConnectionCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchUserQueryVariables,
  APITypes.SearchUserQuery
>;
export const listRecommendedCircle = /* GraphQL */ `query ListRecommendedCircle($limit: Int!) {
  listRecommendedCircle(limit: $limit) {
    id
    name
    description
    imageUrl
    privacy
    event {
      items {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interest
    organizationGroup
    admins
    members {
      items {
        id
        organizationGroup
        role
        status
        requestStatus
        circleUserCircleId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        circleUserUserId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        circleUserInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    isManagedByHR
    creator
    bannerImageUrl
    CGPercent
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecommendedCircleQueryVariables,
  APITypes.ListRecommendedCircleQuery
>;
export const listRecommendedEvent = /* GraphQL */ `query ListRecommendedEvent($limit: Int!) {
  listRecommendedEvent(limit: $limit) {
    id
    organizationGroup
    name
    description
    imageUrl
    startTime
    endTime
    circleEventId
    circle {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    attendee {
      items {
        id
        organizationGroup
        eventAttendeeId
        event {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        eventAttendeeUserId
        status
        requestStatus
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        eventAttendeeInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interests
    privacy
    admins
    timezone
    location
    createdAt
    isManagedByHR
    owner
    isHidden
    bannerImageUrl
    CGPercent
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecommendedEventQueryVariables,
  APITypes.ListRecommendedEventQuery
>;
export const getCGPercentUsers = /* GraphQL */ `query GetCGPercentUsers($userIds: [ID], $limit: Int!) {
  getCGPercentUsers(userIds: $userIds, limit: $limit) {
    userId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    CGPercent
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCGPercentUsersQueryVariables,
  APITypes.GetCGPercentUsersQuery
>;
export const getCGPercentContext = /* GraphQL */ `query GetCGPercentContext(
  $type: CommonGroundReferenceType
  $referenceIds: [ID]
  $limit: Int!
  $isHR: Boolean
) {
  getCGPercentContext(
    type: $type
    referenceIds: $referenceIds
    limit: $limit
    isHR: $isHR
  ) {
    id
    userFrom
    organizationGroup
    referenceId
    referenceType
    CGPercent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCGPercentContextQueryVariables,
  APITypes.GetCGPercentContextQuery
>;
export const getMutualConnections = /* GraphQL */ `query GetMutualConnections($userId: ID!) {
  getMutualConnections(userId: $userId) {
    mutualConnection {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    mutualConnectionWithCG {
      userId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      CGPercent
      __typename
    }
    minimumIntroducers
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMutualConnectionsQueryVariables,
  APITypes.GetMutualConnectionsQuery
>;
export const getMySkills = /* GraphQL */ `query GetMySkills($userId: ID) {
  getMySkills(userId: $userId) {
    skillTrackId
    skillTrackName
    departmentId
    departmentName
    skillCount
    completedSkillCount
    isCompleted
    points
    color
    skills {
      skillId
      name
      description
      level
      levelRank
      isCompleted
      verifiers {
        id
        firstName
        avatarUrl
        isHR
        __typename
      }
      order
      points
      pendingVerificationNotifID
      userSkillId
      skillUserVersion
      isPointEarned
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMySkillsQueryVariables,
  APITypes.GetMySkillsQuery
>;
export const getUserLookingForTypeCount = /* GraphQL */ `query GetUserLookingForTypeCount($lookingForType: UserType, $category: String) {
  getUserLookingForTypeCount(
    lookingForType: $lookingForType
    category: $category
  ) {
    key
    value
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserLookingForTypeCountQueryVariables,
  APITypes.GetUserLookingForTypeCountQuery
>;
export const getMentorshipConnection = /* GraphQL */ `query GetMentorshipConnection(
  $type: UserType
  $category: String
  $timeRangeFilter: TimeRangeFilter
) {
  getMentorshipConnection(
    type: $type
    category: $category
    timeRangeFilter: $timeRangeFilter
  ) {
    data {
      key
      value
      __typename
    }
    month
    date
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMentorshipConnectionQueryVariables,
  APITypes.GetMentorshipConnectionQuery
>;
export const getUserWithRelationshipCount = /* GraphQL */ `query GetUserWithRelationshipCount(
  $usePagination: Boolean
  $limit: Int
  $nextToken: String
) {
  getUserWithRelationshipCount(
    usePagination: $usePagination
    limit: $limit
    nextToken: $nextToken
  ) {
    data {
      id
      firstName
      lastName
      username
      avatarUrl
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      menteesRating
      jobTitle
      department
      type
      lookingForType
      mentorshipCount
      supermentorshipMentorCount
      supermentorshipMenteeCount
      menteesCount
      CGPercent
      points
      mentorshipRatingDetails {
        name
        avatarUrl
        jobTitle
        lookingForType
        rating
        comment
        points
        __typename
      }
      menteeRatingDetails {
        name
        avatarUrl
        jobTitle
        lookingForType
        rating
        comment
        points
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserWithRelationshipCountQueryVariables,
  APITypes.GetUserWithRelationshipCountQuery
>;
export const getOverviewMentorship = /* GraphQL */ `query GetOverviewMentorship($timeRangeFilter: TimeRangeFilter) {
  getOverviewMentorship(timeRangeFilter: $timeRangeFilter) {
    total {
      mentorship
      supermentorship
      ally
      __typename
    }
    incrementPercentageLastMonth {
      mentorship
      supermentorship
      ally
      __typename
    }
    incrementPercentageLastWeek {
      mentorship
      supermentorship
      ally
      __typename
    }
    incrementPercentageYesterday {
      mentorship
      supermentorship
      ally
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOverviewMentorshipQueryVariables,
  APITypes.GetOverviewMentorshipQuery
>;
export const getMySkillOverview = /* GraphQL */ `query GetMySkillOverview($userId: ID) {
  getMySkillOverview(userId: $userId) {
    allSkillCount
    completedSkillCount
    completedSkillIncrementPercentage
    allGoalsTarget
    allGoalsCompleted
    allGoalsIncrementPercentage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMySkillOverviewQueryVariables,
  APITypes.GetMySkillOverviewQuery
>;
export const adminSkillReports = /* GraphQL */ `query AdminSkillReports(
  $timeRangeFilter: TimeRangeFilter
  $inputFlag: AdminSkillReportsFlag
) {
  adminSkillReports(timeRangeFilter: $timeRangeFilter, inputFlag: $inputFlag) {
    activeSkills {
      total
      trend
      __typename
    }
    completedSkills {
      total
      trend
      __typename
    }
    skillTracksByMonth {
      month
      total
      data {
        skillTrackName
        departmentName
        count
        __typename
      }
      __typename
    }
    skillTracksByWeek {
      date
      total
      data {
        skillTrackName
        departmentName
        count
        __typename
      }
      __typename
    }
    skillTracksByDay {
      date
      total
      data {
        skillTrackName
        departmentName
        count
        __typename
      }
      __typename
    }
    mostPopularSkillTrack
    groupActiveSkillsBySkillTrack {
      skillTrackName
      departmentName
      count
      __typename
    }
    skillsByProfiles {
      userID
      jobTitle
      fullName
      type
      lookingForType
      activeSkills
      completedSkills
      focusSkillTrack
      currentSkill
      avatarUrl
      CGPercent
      points
      typeTier
      averageRating
      verifierDetails {
        verifier {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        skillName
        skillTrackName
        departmentName
        departmentLevelName
        rating
        message
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AdminSkillReportsQueryVariables,
  APITypes.AdminSkillReportsQuery
>;
export const getQuickQuestion = /* GraphQL */ `query GetQuickQuestion {
  getQuickQuestion {
    label
    max
    type
    field
    options
    parent
    category
    isSecondTime
    labelIsHTML
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQuickQuestionQueryVariables,
  APITypes.GetQuickQuestionQuery
>;
export const getConnectionsCountCategorized = /* GraphQL */ `query GetConnectionsCountCategorized(
  $month: Int
  $userType: UserType
  $category: String
  $timeRangeFilter: TimeRangeFilter
) {
  getConnectionsCountCategorized(
    month: $month
    userType: $userType
    category: $category
    timeRangeFilter: $timeRangeFilter
  ) {
    data {
      key
      value
      __typename
    }
    month
    date
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConnectionsCountCategorizedQueryVariables,
  APITypes.GetConnectionsCountCategorizedQuery
>;
export const getOverviewConnection = /* GraphQL */ `query GetOverviewConnection($timeRangeFilter: TimeRangeFilter) {
  getOverviewConnection(timeRangeFilter: $timeRangeFilter) {
    total {
      SUPER_MENTOR
      MENTOR
      MENTEE
      ALLY
      FANS
      __typename
    }
    trend {
      SUPER_MENTOR
      MENTOR
      MENTEE
      ALLY
      FANS
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOverviewConnectionQueryVariables,
  APITypes.GetOverviewConnectionQuery
>;
export const getConnectedProfileCount = /* GraphQL */ `query GetConnectedProfileCount {
  getConnectedProfileCount {
    id
    firstName
    lastName
    username
    avatarUrl
    jobTitle
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    departmentName
    type
    points
    lookingForType
    connectionCount
    eventAttendeeCount
    circleUserCount
    redFlagCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConnectedProfileCountQueryVariables,
  APITypes.GetConnectedProfileCountQuery
>;
export const getOverviewHR = /* GraphQL */ `query GetOverviewHR(
  $timeRangeFilter: TimeRangeFilter
  $flagInput: OverviewHRFlagInput
) {
  getOverviewHR(timeRangeFilter: $timeRangeFilter, flagInput: $flagInput) {
    total {
      profilesCount
      redflagCount
      activeCircleCount
      upcomingEventCount
      archivedEventCount
      allProfilesCount
      __typename
    }
    incrementPercentageLastMonth {
      profilesCount
      redflagCount
      activeCircleCount
      upcomingEventCount
      archivedEventCount
      allProfilesCount
      __typename
    }
    incrementPercentageLastWeek {
      profilesCount
      redflagCount
      activeCircleCount
      upcomingEventCount
      archivedEventCount
      allProfilesCount
      __typename
    }
    incrementPercentageYesterday {
      profilesCount
      redflagCount
      activeCircleCount
      upcomingEventCount
      archivedEventCount
      allProfilesCount
      __typename
    }
    engagement {
      month
      date
      superMentorships
      mentorships
      allies
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOverviewHRQueryVariables,
  APITypes.GetOverviewHRQuery
>;
export const getAdminLatestData = /* GraphQL */ `query GetAdminLatestData {
  getAdminLatestData {
    userData {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    circleUserData {
      id
      organizationGroup
      role
      status
      requestStatus
      circleUserCircleId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      circleUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      circleUserInviterId
      __typename
    }
    eventData {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminLatestDataQueryVariables,
  APITypes.GetAdminLatestDataQuery
>;
export const getConnectionAcrossDepartments = /* GraphQL */ `query GetConnectionAcrossDepartments {
  getConnectionAcrossDepartments {
    department
    value
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConnectionAcrossDepartmentsQueryVariables,
  APITypes.GetConnectionAcrossDepartmentsQuery
>;
export const getRedFlagReportCount = /* GraphQL */ `query GetRedFlagReportCount($month: Int) {
  getRedFlagReportCount(month: $month) {
    month
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRedFlagReportCountQueryVariables,
  APITypes.GetRedFlagReportCountQuery
>;
export const getRedFlagDetail = /* GraphQL */ `query GetRedFlagDetail($redFlagId: ID!) {
  getRedFlagDetail(redFlagId: $redFlagId) {
    redFlag {
      id
      organizationGroup
      description
      attachmentUrl
      referenceType
      referenceId
      referenceName
      reporter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      issue
      status
      isCompleted
      completedAt
      isAnonymous
      comment
      comments {
        name
        message
        createdAt
        review
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      redFlagReporterId
      __typename
    }
    imageUrlReference
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRedFlagDetailQueryVariables,
  APITypes.GetRedFlagDetailQuery
>;
export const getUsersPointsProgress = /* GraphQL */ `query GetUsersPointsProgress($userId: ID) {
  getUsersPointsProgress(userId: $userId) {
    statusCode
    rewardsProgress {
      percentToNextTier
      pointsBalance
      sinceLastWeek
      __typename
    }
    nextTier
    pointsToNextTier
    pointsTiers {
      key
      value
      __typename
    }
    pointsBreakdown {
      key
      value
      __typename
    }
    numberOfCircleJoined
    numberOfEventJoined
    numberOfConnection
    numberOfTargetCircle
    numberOfTargetEvent
    numberOfTargetConnection
    totalRedeemReward
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUsersPointsProgressQueryVariables,
  APITypes.GetUsersPointsProgressQuery
>;
export const getPopularInterests = /* GraphQL */ `query GetPopularInterests {
  getPopularInterests {
    id
    organizationGroup
    name
    description
    type
    category
    tagCategoryId
    tagCategory {
      id
      organizationGroup
      name
      tags {
        items {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPopularInterestsQueryVariables,
  APITypes.GetPopularInterestsQuery
>;
export const adminManageContent = /* GraphQL */ `query AdminManageContent(
  $type: AdminManageContentTypes
  $input: AdminManageContentInput
) {
  adminManageContent(type: $type, input: $input) {
    data {
      id
      image
      privacy
      name
      membersCount
      avgCGPercent
      avgMembersPoints
      redFlagsCount
      startTime
      endTime
      timezone
      location
      isManagedByHR
      isHidden
      isOrganizer
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AdminManageContentQueryVariables,
  APITypes.AdminManageContentQuery
>;
export const getCategorizedEvent = /* GraphQL */ `query GetCategorizedEvent($userId: ID, $limit: Int) {
  getCategorizedEvent(userId: $userId, limit: $limit) {
    upcomingEvents {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ongoingEvents {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pastEvents {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCategorizedEventQueryVariables,
  APITypes.GetCategorizedEventQuery
>;
export const getSkillRecommendations = /* GraphQL */ `query GetSkillRecommendations {
  getSkillRecommendations {
    notificationId
    recommender {
      userId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      CGPercent
      __typename
    }
    recommendationType
    skill {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    verifier {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    skillTrack {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    notification {
      id
      description
      message
      status
      userFrom
      userTo
      referenceType
      isFromHR
      createdAt
      referenceID
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillRecommendationsQueryVariables,
  APITypes.GetSkillRecommendationsQuery
>;
export const getSkillWithVerifier = /* GraphQL */ `query GetSkillWithVerifier($targetUserId: ID) {
  getSkillWithVerifier(targetUserId: $targetUserId) {
    verifier {
      userId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      CGPercent
      __typename
    }
    skill {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillWithVerifierQueryVariables,
  APITypes.GetSkillWithVerifierQuery
>;
export const getListNotifRecommendation = /* GraphQL */ `query GetListNotifRecommendation($contextType: NotificationType) {
  getListNotifRecommendation(contextType: $contextType) {
    notifId
    userFrom {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    notifDescription
    notifMessage
    contextId
    context
    contextName
    contextPrivacy
    contextImage
    contextCGPercent
    isFromHR
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetListNotifRecommendationQueryVariables,
  APITypes.GetListNotifRecommendationQuery
>;
export const getSkillVerifiers = /* GraphQL */ `query GetSkillVerifiers($skillId: String) {
  getSkillVerifiers(skillId: $skillId) {
    userId
    user {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    CGPercent
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillVerifiersQueryVariables,
  APITypes.GetSkillVerifiersQuery
>;
export const getActiveSkills = /* GraphQL */ `query GetActiveSkills {
  getActiveSkills {
    total
    trend
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetActiveSkillsQueryVariables,
  APITypes.GetActiveSkillsQuery
>;
export const getCompletedSkills = /* GraphQL */ `query GetCompletedSkills {
  getCompletedSkills {
    total
    trend
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompletedSkillsQueryVariables,
  APITypes.GetCompletedSkillsQuery
>;
export const getSkillTracksByMonth = /* GraphQL */ `query GetSkillTracksByMonth {
  getSkillTracksByMonth {
    month
    total
    data {
      skillTrackName
      departmentName
      count
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillTracksByMonthQueryVariables,
  APITypes.GetSkillTracksByMonthQuery
>;
export const getActiveSkillsBySkillTrack = /* GraphQL */ `query GetActiveSkillsBySkillTrack {
  getActiveSkillsBySkillTrack {
    group {
      skillTrackName
      departmentName
      count
      __typename
    }
    mostPopular
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetActiveSkillsBySkillTrackQueryVariables,
  APITypes.GetActiveSkillsBySkillTrackQuery
>;
export const getSkillsByProfile = /* GraphQL */ `query GetSkillsByProfile(
  $limit: Int
  $usePagination: Boolean
  $nextToken: String
) {
  getSkillsByProfile(
    limit: $limit
    usePagination: $usePagination
    nextToken: $nextToken
  ) {
    data {
      userID
      jobTitle
      fullName
      type
      lookingForType
      activeSkills
      completedSkills
      focusSkillTrack
      currentSkill
      avatarUrl
      CGPercent
      points
      typeTier
      averageRating
      verifierDetails {
        verifier {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        skillName
        skillTrackName
        departmentName
        departmentLevelName
        rating
        message
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillsByProfileQueryVariables,
  APITypes.GetSkillsByProfileQuery
>;
export const getSkillsBySkillTrack = /* GraphQL */ `query GetSkillsBySkillTrack {
  getSkillsBySkillTrack {
    mostPopularSkillTrack
    groupActiveSkillsBySkillTrack {
      skillTrackName
      departmentName
      count
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillsBySkillTrackQueryVariables,
  APITypes.GetSkillsBySkillTrackQuery
>;
export const getSlackOAuthUrl = /* GraphQL */ `query GetSlackOAuthUrl($isInit: Boolean) {
  getSlackOAuthUrl(isInit: $isInit) {
    url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSlackOAuthUrlQueryVariables,
  APITypes.GetSlackOAuthUrlQuery
>;
export const getListSkillByContext = /* GraphQL */ `query GetListSkillByContext($context: EnumSkillContext) {
  getListSkillByContext(context: $context) {
    skills {
      id
      organizationGroup
      name
      description
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillDepartmentId
      trackOrder
      points
      assignees {
        items {
          id
          organizationGroup
          skillId
          skillUserUserId
          completedAt
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      skillTrackId
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      departmentlevelId
      departmentlevel {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        rank
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      level
      levelRank
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    skillTracks {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetListSkillByContextQueryVariables,
  APITypes.GetListSkillByContextQuery
>;
export const getRewardReports = /* GraphQL */ `query GetRewardReports(
  $timeRangeFilter: DynamicTimeRangeFilter
  $isStaticRange: Boolean
  $year: Int
  $month: Int
) {
  getRewardReports(
    timeRangeFilter: $timeRangeFilter
    isStaticRange: $isStaticRange
    year: $year
    month: $month
  ) {
    rewardTrend {
      total
      trend
      __typename
    }
    mostPopularReward
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRewardReportsQueryVariables,
  APITypes.GetRewardReportsQuery
>;
export const getRedeemedRewards = /* GraphQL */ `query GetRedeemedRewards(
  $timeRangeFilter: DynamicTimeRangeFilter
  $isStaticRange: Boolean
  $year: Int
  $month: Int
) {
  getRedeemedRewards(
    timeRangeFilter: $timeRangeFilter
    isStaticRange: $isStaticRange
    year: $year
    month: $month
  ) {
    data {
      id
      createdAt
      rewardName
      rewardPoint
      user {
        fullName
        jobTitle
        lookingFor
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRedeemedRewardsQueryVariables,
  APITypes.GetRedeemedRewardsQuery
>;
export const getSkillVerificationNotifications = /* GraphQL */ `query GetSkillVerificationNotifications {
  getSkillVerificationNotifications {
    data {
      id
      createdAt
      referenceID
      referenceType
      status
      color
      userFrom
      userTo
      isFromHR
      message
      description
      completeSkillName
      userFromName
      userFromAvatarUrl
      skillDepartmentName
      userFromPoint
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillVerificationNotificationsQueryVariables,
  APITypes.GetSkillVerificationNotificationsQuery
>;
export const getListContext = /* GraphQL */ `query GetListContext(
  $id: ID
  $context: [PostContext]
  $isHR: Boolean
  $limit: Int
  $nextToken: String
  $usePagination: Boolean
) {
  getListContext(
    id: $id
    context: $context
    isHR: $isHR
    limit: $limit
    nextToken: $nextToken
    usePagination: $usePagination
  ) {
    events {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    circles {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    users {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userPosts {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    recommendedCircles {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isHidden
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    recommendedEvents {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      isHidden
      bannerImageUrl
      CGPercent
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    recommendedConnections {
      userId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      CGPercent
      __typename
    }
    teaPosts {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    eligibleUsersToCircle {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    eligibleUsersToEvent {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      zipCode
      collegeMajor
      isFirstGenerationCollege
      highSchool
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetListContextQueryVariables,
  APITypes.GetListContextQuery
>;
export const getLeaderboards = /* GraphQL */ `query GetLeaderboards($isMyDepartment: Boolean) {
  getLeaderboards(isMyDepartment: $isMyDepartment) {
    id
    cognitoID
    email
    organizationGroup
    firstName
    lastName
    username
    avatarUrl
    bannerImageUrl
    bio
    jobTitle
    type
    lookingForType
    isClosedForAcceptingMentee
    joinedAt
    lastLoginAt
    deletedAt
    deletedBy
    phone
    points
    lifetimePoints
    dateOfBirth
    isOnboarded
    disabledQuickQuestion
    finishedUserGuideContext
    focusedSkillTrack {
      id
      organizationGroup
      departmentId
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tag {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      skillTrackTagId
      name
      color
      skills {
        items {
          id
          organizationGroup
          name
          description
          skillDepartmentId
          trackOrder
          points
          skillTrackId
          departmentlevelId
          level
          levelRank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    minimumIntroducers
    givenRatings {
      items {
        id
        userFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        organizationGroup
        ratingValue
        comment
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    receivedRatings {
      items {
        id
        userFromId
        userFrom {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userFromType
        userToId
        userTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        userToType
        organizationGroup
        ratingValue
        comment
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    averageRating
    avgMentorRating
    avgMenteeRating
    avgAllyRating
    userHomepageConfig
    socialMedia {
      linkedIn
      __typename
    }
    targetGoals {
      circle
      event
      connection
      __typename
    }
    interest
    expertises
    department {
      id
      name
      description
      organizationGroup
      skillTracks {
        items {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      levels {
        items {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    awards
    titleRank
    sensitiveQuestionConsent
    isAskedTwiceAlready
    skippedSensitiveQuestion {
      dateOfBirth
      sexuality
      religion
      class
      relationshipStatus
      category
      taxBracket
      nativeBorn
      birthCity
      moonSign
      sunSign
      generation
      favePoliticalParty
      __typename
    }
    ethnicity
    sexuality
    extrovertOrIntrovert
    sensingOrIntuition
    thinkingOrFeeling
    judgingOrPerceiving
    personalityType
    religion
    class
    relationshipStatus
    childhoodZip
    dogOwner
    catOwner
    moonSign
    sunSign
    morningVsNightPerson
    hasSiblings
    birthOrder
    heroes
    sages
    celebsLoveToMeet
    personalityTest
    eatOutVsEatIn
    almaMater
    gender
    race
    vegan
    taxBracket
    nativeBorn
    currentZip
    artist
    musicalInstrument
    generation
    companyClub
    favorites {
      faveMusicGenre
      faveSinger
      faveMuseum
      faveSportTeam
      faveSport
      faveLanguage
      faveTVShow
      faveBoardGame
      faveVideoGame
      faveBook
      faveTheatreShow
      faveVacation
      faveNewsSource
      faveCity
      faveRestaurant
      faveBar
      faveNightClub
      favePoliticalParty
      faveCharities
      faveDrink
      __typename
    }
    workBehaviours {
      collaboration
      motivation
      pressure
      workLifeBalance
      communication
      openOfficeEnvirontment
      contributorOrManager
      __typename
    }
    totalSiblings
    vegetarian
    birthCountry
    birthCity
    introVsExtro
    selectedFavorites
    zipCode
    collegeMajor
    isFirstGenerationCollege
    highSchool
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    userFocusedSkillTrackId
    userDepartmentId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLeaderboardsQueryVariables,
  APITypes.GetLeaderboardsQuery
>;
export const getMyActivities = /* GraphQL */ `query GetMyActivities($startTime: AWSDateTime, $endTime: AWSDateTime) {
  getMyActivities(startTime: $startTime, endTime: $endTime) {
    orderedItems {
      id
      createdAt
      type
      __typename
    }
    activities {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      contextImage
      isContextHidden
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isContextDeleted
      isHighlight
      audienceType
      audienceID
      comments {
        items {
          id
          commentPostId
          organizationGroup
          commentAuthorId
          likeUsers
          message
          isAuthorHR
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    circleRecommendations {
      notifId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      notifDescription
      notifMessage
      contextId
      context
      contextName
      contextPrivacy
      contextImage
      contextCGPercent
      contextPoint
      contextIsHidden
      isFromHR
      createdAt
      __typename
    }
    eventRecommendations {
      notifId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      notifDescription
      notifMessage
      contextId
      context
      contextName
      contextPrivacy
      contextImage
      contextCGPercent
      contextPoint
      contextIsHidden
      isFromHR
      createdAt
      __typename
    }
    connectionRecommendations {
      notifId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      notifDescription
      notifMessage
      contextId
      context
      contextName
      contextPrivacy
      contextImage
      contextCGPercent
      contextPoint
      contextIsHidden
      isFromHR
      createdAt
      __typename
    }
    skillRecommendations {
      notificationId
      recommender {
        userId
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        CGPercent
        __typename
      }
      recommendationType
      skill {
        id
        organizationGroup
        name
        description
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillDepartmentId
        trackOrder
        points
        assignees {
          nextToken
          startedAt
          __typename
        }
        skillTrackId
        skillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        departmentlevelId
        departmentlevel {
          id
          organizationGroup
          departmentId
          name
          rank
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        level
        levelRank
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      verifier {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      skillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          tagCategoryId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      notification {
        id
        description
        message
        status
        userFrom
        userTo
        referenceType
        isFromHR
        createdAt
        referenceID
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      __typename
    }
    endorsements {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    activeEndorsements {
      id
      description
      status
      endorsementAssignedToId
      endorsementCreatedById
      previousEndorsementId
      previousEndorsement {
        id
        description
        status
        endorsementAssignedToId
        endorsementCreatedById
        previousEndorsementId
        previousEndorsement {
          id
          description
          status
          endorsementAssignedToId
          endorsementCreatedById
          previousEndorsementId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        assignedTo {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdBy {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdBy {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    circleInvitations {
      id
      organizationGroup
      role
      status
      requestStatus
      circleUserCircleId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      circleUserUserId
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      circleUserInviterId
      __typename
    }
    eventInvitations {
      id
      organizationGroup
      eventAttendeeId
      event {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      eventAttendeeUserId
      status
      requestStatus
      user {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviter {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      inviterNotes
      isInviterHR
      requestNotes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      eventAttendeeInviterId
      __typename
    }
    championRequests {
      id
      organizationGroup
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      status
      requestMessage
      approvedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    championInvitations {
      id
      organizationGroup
      userFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      status
      requestMessage
      approvedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    mentorshipRequests {
      id
      description
      status
      approvedAt
      organizationGroup
      connectionUserFromId
      userFrom {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userFromType
      userFromRequestType
      userFromRequestStatus
      connectionUserToId
      userTo {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        zipCode
        collegeMajor
        isFirstGenerationCollege
        highSchool
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      userToType
      userToRequestType
      userToRequestStatus
      introductionRequests {
        items {
          id
          userFromType
          userToType
          introductionRequestUserFromId
          introductionRequestUserToId
          introducerId
          reason
          status
          message
          connectionId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          introductionRequestIntroducerId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    connectionActivities {
      notifId
      description
      message
      status
      userFromId
      userFromName
      userFromAvatar
      userFromPoint
      userTo
      referenceType
      isFromHR
      referenceID
      createdAt
      __typename
    }
    skillVerificationRequests {
      id
      createdAt
      referenceID
      referenceType
      status
      color
      userFrom
      userTo
      isFromHR
      message
      description
      completeSkillName
      userFromName
      userFromAvatarUrl
      skillDepartmentName
      userFromPoint
      __typename
    }
    relationshipUpgradeRequests {
      notifId
      description
      message
      status
      userFromId
      userFromName
      userFromAvatar
      userFromPoint
      userTo
      referenceType
      isFromHR
      referenceID
      createdAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMyActivitiesQueryVariables,
  APITypes.GetMyActivitiesQuery
>;
export const compareUserSimilarity = /* GraphQL */ `query CompareUserSimilarity($targetUserId: ID) {
  compareUserSimilarity(targetUserId: $targetUserId) {
    events {
      event {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        circle {
          id
          name
          description
          imageUrl
          privacy
          interest
          organizationGroup
          admins
          createdAt
          isManagedByHR
          creator
          bannerImageUrl
          CGPercent
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        attendee {
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        timezone
        location
        createdAt
        isManagedByHR
        owner
        isHidden
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      joinedAt
      isCommon
      __typename
    }
    circles {
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        bannerImageUrl
        CGPercent
        isUserHasPendingRequest
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      joinedAt
      isCommon
      __typename
    }
    interests {
      interest {
        id
        organizationGroup
        name
        description
        type
        category
        tagCategoryId
        tagCategory {
          id
          organizationGroup
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      isCommon
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CompareUserSimilarityQueryVariables,
  APITypes.CompareUserSimilarityQuery
>;
